webpackJsonp([9],{

/***/ 1111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsEventView_vue__ = __webpack_require__(1261);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4752e942_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsEventView_vue__ = __webpack_require__(1396);
function injectStyle (ssrContext) {
  __webpack_require__(1389)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsEventView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4752e942_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsEventView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useFormAlert() {
  var message = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var type = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('warning');
  var timer = null;

  function apply(msg, autoDismiss) {
    message.value = msg;

    if (autoDismiss) {
      timer = setTimeout(function () {
        message.value = null;
      }, 5000);
    }
  }

  function show(msg, alertType, autoDismiss) {
    clearTimeout(timer);
    type.value = alertType;

    if (message.value != null) {
      message.value = null;
      Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
        return apply(msg, autoDismiss);
      });
    } else {
      apply(msg, autoDismiss);
    }
  }

  function showError(msg) {
    show(msg, 'warning', true);
  }

  function showSuccess(msg) {
    show(msg != null ? msg : 'Success', 'success', true);
  }

  function showPersistentError(msg) {
    show(msg, 'warning', false);
  }

  function clear() {
    clearTimeout(timer);
    message.value = null;
  }

  return {
    message: message,
    type: type,
    showError: showError,
    showSuccess: showSuccess,
    showPersistentError: showPersistentError,
    clear: clear
  };
}

/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppTabSwitcher',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    modelValue: function modelValue() {
      return this.value;
    }
  }
});

/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__ = __webpack_require__(1139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__ = __webpack_require__(1157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-switcher"},_vm._l((_vm.items),function(item){return _c('a',{key:item.value,staticClass:"tab-switcher__tab",class:{ 'tab-switcher__tab--active': _vm.modelValue === item.value },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('input', item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppTabSwitcher__ = __webpack_require__(1156);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TabSearchBar',
  components: {
    AppTabSwitcher: __WEBPACK_IMPORTED_MODULE_0__components_AppTabSwitcher__["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      default: null
    },
    search: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search'
    }
  }
});

/***/ }),

/***/ 1187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getCalculator: function getCalculator(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/calculator"));
  },
  createCalculator: function createCalculator(eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/calculator"), data, {
      silent: true
    });
  },
  updateCalculator: function updateCalculator(calculatorId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/calculators/".concat(calculatorId), data, {
      silent: true
    });
  },
  getDraftPrizeSummary: function getDraftPrizeSummary(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/prize-summary"));
  }
});

/***/ }),

/***/ 1216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabSearchBar_vue__ = __webpack_require__(1181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e38d96c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabSearchBar_vue__ = __webpack_require__(1219);
function injectStyle (ssrContext) {
  __webpack_require__(1217)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e38d96c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabSearchBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e38d96c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabSearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1217:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1218);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("5f78b919", content, true, {});

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".tab-search-bar__search[data-v-9e38d96c]{position:relative;flex-grow:1;min-width:220px;max-width:400px}.tab-search-bar__search .form-control[data-v-9e38d96c]{width:100%;padding-right:2rem}.tab-search-bar__icon[data-v-9e38d96c]{position:absolute;right:.6rem;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);pointer-events:none;opacity:.5}@media (max-width:768px){.tab-search-bar[data-v-9e38d96c]{flex-direction:column!important;align-items:flex-start!important}.tab-search-bar>[data-v-9e38d96c]{width:100%;margin-left:0!important;margin-right:0!important}.tab-search-bar__search[data-v-9e38d96c]{max-width:none}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/TabSearchBar.vue"],"names":[],"mappings":"AACA,yCACE,kBAAmB,AACnB,YAAa,AACb,gBAAiB,AACjB,eAAiB,CAClB,AACD,uDACE,WAAY,AACZ,kBAAoB,CACrB,AACD,uCACE,kBAAmB,AACnB,YAAc,AACd,QAAS,AACT,mCAAoC,AAC5B,2BAA4B,AACpC,oBAAqB,AACrB,UAAa,CACd,AACD,yBACA,iCACI,gCAAkC,AAClC,gCAAmC,CACtC,AACD,kCACI,WAAY,AACZ,wBAA0B,AAC1B,wBAA2B,CAC9B,AACD,yCACI,cAAgB,CACnB,CACA","file":"TabSearchBar.vue","sourcesContent":["\n.tab-search-bar__search[data-v-9e38d96c] {\n  position: relative;\n  flex-grow: 1;\n  min-width: 220px;\n  max-width: 400px;\n}\n.tab-search-bar__search .form-control[data-v-9e38d96c] {\n  width: 100%;\n  padding-right: 2rem;\n}\n.tab-search-bar__icon[data-v-9e38d96c] {\n  position: absolute;\n  right: 0.6rem;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  pointer-events: none;\n  opacity: 0.5;\n}\n@media (max-width: 768px) {\n.tab-search-bar[data-v-9e38d96c] {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n}\n.tab-search-bar > *[data-v-9e38d96c] {\n    width: 100%;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n.tab-search-bar__search[data-v-9e38d96c] {\n    max-width: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-search-bar d-flex flex-wrap align-items-center justify-content-between mb-3"},[_c('app-tab-switcher',{staticClass:"mr-3 mb-2",attrs:{"items":_vm.items,"value":_vm.activeTab},on:{"input":function($event){return _vm.$emit('tab-change', $event)}}}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-end flex-grow-1 ml-3 mb-2"},[_c('label',{staticClass:"d-none d-lg-block mr-2 mb-0 font-weight-normal"},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"tab-search-bar__search"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.search},on:{"input":function($event){return _vm.$emit('search-input', $event.target.value)}}}),_vm._v(" "),_c('svg',{staticClass:"tab-search-bar__icon",attrs:{"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TabSearchBar__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppTooltip__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_draws_useDrawsEventView__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_useFormAlert__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Draws_DrawRow__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api_nominations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_api_draws__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_EventBus__ = __webpack_require__(18);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DrawsEventView',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_2__components_ConfirmModal__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */],
    TabSearchBar: __WEBPACK_IMPORTED_MODULE_4__components_TabSearchBar__["a" /* default */],
    AppTooltip: __WEBPACK_IMPORTED_MODULE_5__components_AppTooltip__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_8__components_FormAlert__["a" /* default */],
    DrawRow: __WEBPACK_IMPORTED_MODULE_10__components_Draws_DrawRow__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default.a,
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_11__components_AppMultiselect__["a" /* default */]
  },
  setup: function setup() {
    var vm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])();
    var route = vm.proxy.$route;
    var draftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return vm.proxy.$route.params.draftId;
    });
    var eventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return vm.proxy.$route.params.eventId;
    });
    var alert = Object(__WEBPACK_IMPORTED_MODULE_7__composables_useFormAlert__["a" /* default */])();
    var rowAlerts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({});
    var rowTimers = {};
    var actionLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var pendingMarks = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({});
    var pendingMarkCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);
    var isMarking = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return pendingMarkCount.value > 0;
    });
    var actionCount = 0;

    var refreshTieCheckFn = function refreshTieCheckFn() {};

    function handleRowAction(drawId, promise, markField) {
      if (!markField) {
        actionCount += 1;
        actionLoading.value = true;
      } else {
        var key = "".concat(drawId, "_").concat(markField);
        Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["m" /* set */])(pendingMarks, key, true);
        pendingMarkCount.value += 1;
      }

      promise.then(function (result) {
        if (result == null || result.message == null) return;
        Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["m" /* set */])(rowAlerts, drawId, result);
        clearTimeout(rowTimers[drawId]);
        rowTimers[drawId] = setTimeout(function () {
          Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["m" /* set */])(rowAlerts, drawId, null);
        }, 5000);
      }).finally(function () {
        if (markField) {
          var _key = "".concat(drawId, "_").concat(markField);

          Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["m" /* set */])(pendingMarks, _key, false);
          pendingMarkCount.value -= 1;

          if (pendingMarkCount.value <= 0) {
            pendingMarkCount.value = 0;
            refreshTieCheckFn();
          }
        } else {
          actionCount -= 1;

          if (actionCount <= 0) {
            actionCount = 0;
            actionLoading.value = false;
          }
        }
      });
    }

    var search = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var showConfirm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var showAddNomination = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var showSwapNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var swapFrom = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var swapTo = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var showPrintMenu = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var showRefundConfirm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var refundLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var showPublishConfirm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var showRegenerateConfirm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var showCleanSlateConfirm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var generateScore = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var generateScores = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
    var showScratchConfirm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var pendingScratchDraw = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var showMoveNotifyConfirm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var pendingMoveAction = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var nomMember = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var nomHorse = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var nomPlace = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var nomEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var nomMemberOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var nomHorseOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var nomMemberLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var nomMemberSearched = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var nomHorseLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var nomSubmitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    var _useDrawsEventView = Object(__WEBPACK_IMPORTED_MODULE_6__composables_draws_useDrawsEventView__["a" /* default */])(eventId, draftId, route.params.round),
        rounds = _useDrawsEventView.rounds,
        draws = _useDrawsEventView.draws,
        emptyDrawsOrders = _useDrawsEventView.emptyDrawsOrders,
        emptySlots = _useDrawsEventView.emptySlots,
        swapCandidates = _useDrawsEventView.swapCandidates,
        swapCandidatesLoading = _useDrawsEventView.swapCandidatesLoading,
        unpublishedDrawsCount = _useDrawsEventView.unpublishedDrawsCount,
        isNextRoundGenerated = _useDrawsEventView.isNextRoundGenerated,
        paymentMethods = _useDrawsEventView.paymentMethods,
        disabledPaymentMethods = _useDrawsEventView.disabledPaymentMethods,
        loading = _useDrawsEventView.loading,
        loadingMore = _useDrawsEventView.loadingMore,
        hasMore = _useDrawsEventView.hasMore,
        redirectTo = _useDrawsEventView.redirectTo,
        activeRound = _useDrawsEventView.activeRound,
        eventName = _useDrawsEventView.eventName,
        judgesNum = _useDrawsEventView.judgesNum,
        fetchAll = _useDrawsEventView.fetchAll,
        fetchSwapCandidates = _useDrawsEventView.fetchSwapCandidates,
        loadMore = _useDrawsEventView.loadMore,
        refreshDraws = _useDrawsEventView.refreshDraws,
        refreshDrawsAndMeta = _useDrawsEventView.refreshDrawsAndMeta,
        markDraw = _useDrawsEventView.markDraw,
        deleteDraw = _useDrawsEventView.deleteDraw,
        moveDraw = _useDrawsEventView.moveDraw,
        swapDraws = _useDrawsEventView.swapDraws,
        refundDraws = _useDrawsEventView.refundDraws,
        fetchRefundStatus = _useDrawsEventView.fetchRefundStatus,
        existScratchedDraw = _useDrawsEventView.existScratchedDraw,
        draftEvents = _useDrawsEventView.draftEvents,
        refundQueueNotEmpty = _useDrawsEventView.refundQueueNotEmpty,
        isBrotherCombSplit = _useDrawsEventView.isBrotherCombSplit,
        isParentSplit = _useDrawsEventView.isParentSplit,
        parentEventId = _useDrawsEventView.parentEventId,
        childrenEventListWithParent = _useDrawsEventView.childrenEventListWithParent,
        finalEvent = _useDrawsEventView.finalEvent,
        eventRoundsNum = _useDrawsEventView.eventRoundsNum,
        lastRoundIndex = _useDrawsEventView.lastRoundIndex,
        finalRoundExists = _useDrawsEventView.finalRoundExists,
        calculatorId = _useDrawsEventView.calculatorId,
        calculator = _useDrawsEventView.calculator,
        showRunOffPanel = _useDrawsEventView.showRunOffPanel,
        hasTiedWinners = _useDrawsEventView.hasTiedWinners,
        refreshTieCheck = _useDrawsEventView.refreshTieCheck,
        showNotificationsModal = _useDrawsEventView.showNotificationsModal,
        insertDraw = _useDrawsEventView.insertDraw,
        restoreDraw = _useDrawsEventView.restoreDraw,
        cleanSlate = _useDrawsEventView.cleanSlate,
        publishRound = _useDrawsEventView.publishRound,
        resetTotalScore = _useDrawsEventView.resetTotalScore,
        resendNotifications = _useDrawsEventView.resendNotifications,
        updateStatus = _useDrawsEventView.updateStatus,
        setRound = _useDrawsEventView.setRound,
        reorderDraw = _useDrawsEventView.reorderDraw,
        regenerateFirstRound = _useDrawsEventView.regenerateFirstRound,
        generateRunOff = _useDrawsEventView.generateRunOff,
        createCalculator = _useDrawsEventView.createCalculator,
        generateNext = _useDrawsEventView.generateNext,
        generateInto = _useDrawsEventView.generateInto,
        updateCommit = _useDrawsEventView.updateCommit,
        togglePaymentStatus = _useDrawsEventView.togglePaymentStatus,
        scoreLimits = _useDrawsEventView.scoreLimits;

    refreshTieCheckFn = refreshTieCheck;
    var router = vm.proxy.$router;
    var swapOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return swapCandidates.value.map(function (c) {
        var label = "".concat(c.order + 1, ". ").concat(c.member_name || 'Empty');
        if (c.horse_name) label += " (".concat(c.horse_name, ")");
        return {
          id: c.id,
          label: label
        };
      });
    });
    var currentRoundType = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var r = rounds.value.find(function (rd) {
        return rd.index === activeRound.value - 1;
      });
      return r != null ? r.type : 1;
    });
    var isFinalRound = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return currentRoundType.value === 3;
    }); // A standalone split-combined final has one round but carries scores from its source events,
    // so it needs Clean Slate just like the final round of a multi-round event.

    var canResetTotalScore = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return isFinalRound.value && unpublishedDrawsCount.value > 0 && (eventRoundsNum.value > 1 || isBrotherCombSplit.value);
    });
    var generateLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var total = eventRoundsNum.value;
      if (activeRound.value + 1 < total) return 'Minimum score to go into the next round';
      return 'Minimum score to go into the Final';
    });
    var hasChildrenEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var list = childrenEventListWithParent.value;
      return list.length > 1;
    });
    var isCombinedNotSplit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return hasChildrenEvents.value && !isParentSplit.value;
    }); // Event switcher next to the title: keeps the kind of round (the shared first round stays on
    // round 1, a final stays on the target's last round).

    var showEventSwitch = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function eventSwitchTarget(e) {
      var round = activeRound.value > 1 ? Math.max(e.rounds, 1) : 1;
      return "/draws/".concat(draftId.value, "/").concat(e.id, "/").concat(round);
    }

    function closeEventSwitch() {
      showEventSwitch.value = false;
    }

    var displayEventName = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (isCombinedNotSplit.value && activeRound.value === 1) {
        var parent = childrenEventListWithParent.value[0];
        return parent != null ? parent.name : eventName.value;
      }

      return eventName.value;
    });
    var childEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (!hasChildrenEvents.value) return [];
      return childrenEventListWithParent.value.slice(1);
    });
    var isFirstRoundInsert = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return activeRound.value === 1 && !isBrotherCombSplit.value;
    });
    var addNomButtonLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return isFirstRoundInsert.value ? 'Add new nomination' : 'Restore nomination';
    });
    var nomMemberEmptyMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return isFirstRoundInsert.value && !nomMemberSearched.value ? 'Type at least 3 characters to search' : 'No competitors found';
    });
    var nomPlaceOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return emptySlots.value.map(function (s) {
        return {
          id: s.id,
          label: String(s.order)
        };
      });
    });
    var nomEventOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var list = childrenEventListWithParent.value;
      var isSplit = isParentSplit.value;
      var isRound1 = activeRound.value === 1;
      var fe = finalEvent.value;
      var evName = eventName.value;
      return list.filter(function (e, idx) {
        // restrict_single_nomination blocks creating a brand-new standalone nomination in this
        // child (NominationService::loadAndAssertEvent) — only relevant for Insert. For Restore
        // the competitor already has an existing nomination filed under this child (e.g. a
        // combined-nominated Maiden + Maiden For Maiden pair) and picking it here just tells
        // DrawService::restore which one to link the draw row to — hiding it made a valid
        // restore target impossible to select (see task-CAM-1484.md).
        if (isFirstRoundInsert.value && e.restrict_single_nomination) return false;
        if (isSplit && isRound1 && idx === 2) return false; // The parent is a valid choice for Insert (round 1) — selecting it there is exactly
        // how a combined nomination across all children gets created (DrawService::insert
        // resolves selected_event_id's own children). For Restore it's meaningless — a
        // nomination's event_id is never the parent, so restoring "into" it can never find
        // one (see task-CAM-1432.md) — hide it there, except the round-1 split merge case,
        // where this same list entry is relabelled below into "this child & final", not the
        // raw parent.

        if (!isFirstRoundInsert.value && e.id === parentEventId.value && !(isSplit && isRound1)) return false;
        return true;
      }).map(function (e) {
        var label = e.name;

        if (isSplit && isRound1) {
          if (fe && e.id === parentEventId.value) {
            label = "".concat(evName, " & ").concat(fe.name);
          } else {
            label = evName;
          }
        }

        return {
          id: e.id,
          label: label
        };
      });
    }); // A genuine split child (isParentSplit, not the final) is fully independent at round 2+ — no
    // shared pool with its sibling, so there's nothing meaningful to choose for Restore and picking
    // the wrong sibling would misfile it. Round 1 insert keeps the picker (it has its own
    // this-child/this-child+final merge option, see nomEventOptions). Combined-not-split (shared
    // pool) and the split-comb final (nomination can come from either child) always need it.

    var showEventSelect = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return childrenEventListWithParent.value.length > 0 && (isFirstRoundInsert.value || !isParentSplit.value || isBrotherCombSplit.value);
    }); // Restore parity (DrawService::restore): filling a specific vacant place is a plain UPDATE
    // that never touches the slot's own event — "Choose event" can't override where it lands or
    // which nomination it's linked to once a specific place is picked. It only matters when
    // restoring to "Last" (a brand-new row, where it decides the event). Insert (round 1) always
    // keeps it live regardless of place, since there it also drives combined-nomination creation.

    var isEventSelectIgnored = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return !isFirstRoundInsert.value && !!nomPlace.value && nomPlace.value.id !== 'last';
    });
    var nomEventHelpText = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (isFirstRoundInsert.value) {
        return 'Determines which event(s) this nomination is created for.';
      }

      return isEventSelectIgnored.value ? 'Ignored — the vacant place you picked already fixes the event. Only used when restoring to "Last".' : 'Only affects restoring to "Last" — has no effect once a specific vacant place is picked above.';
    });
    var memberSearchTimer = null; // Secretary/admin hint: why an otherwise-unfinancial member is nominatable (CAM-1485)

    function memberVolunteerLabel(name, m) {
      if (m && m.is_volunteer) return "".concat(name, " (Volunteer)");
      if (m && m.is_volunteer_family) return "".concat(name, " (Volunteer family)");
      return name;
    } // Restore candidate pool is scoped server-side to the previous round, so it's small enough
    // to show up front (first N) without requiring the user to type anything first.


    function fetchRestoreMembers(term) {
      return __WEBPACK_IMPORTED_MODULE_13__services_api_draws__["a" /* default */].memberSearch(eventId.value, activeRound.value - 1, {
        term: term || undefined
      }).then(function (res) {
        return res.data.data.map(function (m) {
          return {
            id: m.id,
            label: memberVolunteerLabel(m.text, m)
          };
        });
      });
    }

    function onMemberDropdownOpen() {
      if (isFirstRoundInsert.value || nomMemberSearched.value) return;
      nomMemberLoading.value = true;
      fetchRestoreMembers('').then(function (options) {
        nomMemberOptions.value = options;
        nomMemberSearched.value = true;
      }).catch(function () {
        nomMemberOptions.value = [];
      }).finally(function () {
        nomMemberLoading.value = false;
      });
    }

    function onMemberSearch(term) {
      if (!isFirstRoundInsert.value) {
        clearTimeout(memberSearchTimer);
        memberSearchTimer = setTimeout(function () {
          nomMemberLoading.value = true;
          fetchRestoreMembers(term).then(function (options) {
            nomMemberOptions.value = options;
            nomMemberSearched.value = true;
          }).catch(function () {
            nomMemberOptions.value = [];
          }).finally(function () {
            nomMemberLoading.value = false;
          });
        }, 400);
        return;
      }

      if (!term || term.length < 3) {
        nomMemberOptions.value = [];
        nomMemberSearched.value = false;
        return;
      }

      clearTimeout(memberSearchTimer);
      memberSearchTimer = setTimeout(function () {
        nomMemberLoading.value = true;
        __WEBPACK_IMPORTED_MODULE_12__services_api_nominations__["a" /* default */].membersSearch({
          q: term
        }).then(function (res) {
          nomMemberOptions.value = res.data.data.map(function (m) {
            return {
              id: m.id,
              label: memberVolunteerLabel(m.full_name, m)
            };
          });
          nomMemberSearched.value = true;
        }).catch(function () {
          nomMemberOptions.value = [];
        }).finally(function () {
          nomMemberLoading.value = false;
        });
      }, 400);
    }

    function onMemberSelect(member) {
      nomMember.value = member;
      nomHorse.value = null;
      nomHorseOptions.value = [];
      if (!member) return;
      nomHorseLoading.value = true;

      if (isFirstRoundInsert.value) {
        var horseEventId = parentEventId.value != null ? parentEventId.value : eventId.value;
        __WEBPACK_IMPORTED_MODULE_12__services_api_nominations__["a" /* default */].memberHorses(member.id, {
          event_id: horseEventId,
          for_draws: 1
        }).then(function (res) {
          var horses = res.data.data.horses != null ? res.data.data.horses : [];
          nomHorseOptions.value = horses.map(function (h) {
            return {
              id: h.id,
              label: h.disabled_reason ? "".concat(h.name, " (").concat(h.disabled_reason, ")") : h.name,
              $isDisabled: !!h.disabled
            };
          });
        }).catch(function () {
          nomHorseOptions.value = [];
        }).finally(function () {
          nomHorseLoading.value = false;
        });
      } else {
        // Restore (round > 0): candidates are horses this member ran in the previous round,
        // scoped server-side via the round-aware endpoint (parity with monolith getAllHorsesInEvent).
        __WEBPACK_IMPORTED_MODULE_13__services_api_draws__["a" /* default */].memberHorses(eventId.value, activeRound.value - 1, member.id).then(function (res) {
          nomHorseOptions.value = res.data.data.map(function (h) {
            return {
              id: h.id,
              label: h.name
            };
          });
        }).catch(function () {
          nomHorseOptions.value = [];
        }).finally(function () {
          nomHorseLoading.value = false;
        });
      }
    }

    function resetNomForm() {
      nomMember.value = null;
      nomHorse.value = null;
      nomPlace.value = null;
      nomEvent.value = null;
      nomMemberOptions.value = [];
      nomHorseOptions.value = [];
      nomMemberSearched.value = false;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(showAddNomination, function (val) {
      if (val) resetNomForm();
    });

    function onAddNomination() {
      return _onAddNomination.apply(this, arguments);
    }

    function _onAddNomination() {
      _onAddNomination = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result, payload, drawId, _payload;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!nomMember.value || !nomHorse.value || !nomPlace.value)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                nomSubmitting.value = true;

                if (!isFirstRoundInsert.value) {
                  _context2.next = 12;
                  break;
                }

                payload = {
                  draw_id: nomPlace.value.id,
                  member_id: nomMember.value.id,
                  horse_id: nomHorse.value.id
                };

                if (nomEvent.value) {
                  payload.selected_event_id = nomEvent.value.id;
                }

                if (isParentSplit.value) {
                  payload.current_event_id = eventId.value;
                }

                _context2.next = 9;
                return insertDraw(payload);

              case 9:
                result = _context2.sent;
                _context2.next = 18;
                break;

              case 12:
                drawId = nomPlace.value.id;
                _payload = {
                  member_id: nomMember.value.id,
                  horse_id: nomHorse.value.id,
                  event_id: eventId.value,
                  round: activeRound.value - 1
                };

                if (nomEvent.value) {
                  _payload.selected_event_id = nomEvent.value.id;
                }

                _context2.next = 17;
                return restoreDraw(drawId, _payload);

              case 17:
                result = _context2.sent;

              case 18:
                nomSubmitting.value = false;

                if (result != null && result.message != null) {
                  if (result.type === 'success') {
                    alert.showSuccess(result.message);
                    showAddNomination.value = false;
                  } else {
                    alert.showError(result.message);
                  }
                }

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _onAddNomination.apply(this, arguments);
    }

    var roundTabItems = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return rounds.value.filter(function (r) {
        return r != null;
      }).map(function (r) {
        return {
          value: String(r.index + 1),
          label: r.label
        };
      });
    });
    var commitOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    __WEBPACK_IMPORTED_MODULE_12__services_api_nominations__["a" /* default */].getCommits().then(function (res) {
      commitOptions.value = res.data.data;
    });
    var sortField = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('order');
    var sortDir = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('asc');

    function toggleSort(field) {
      if (sortField.value === field) {
        sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc';
      } else {
        sortField.value = field;
        sortDir.value = field === 'order' ? 'asc' : 'desc';
      }
    }

    var filteredDraws = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var q = search.value.toLowerCase().trim();
      var list = draws.value;

      if (q) {
        list = list.filter(function (d) {
          var member = d.member;
          var memberName = member != null ? "".concat(member.first_name, " ").concat(member.last_name).toLowerCase() : '';
          var horseName = d.horse != null ? d.horse.name.toLowerCase() : '';
          return memberName.indexOf(q) !== -1 || horseName.indexOf(q) !== -1;
        });
      }

      return list.slice().sort(function (a, b) {
        var av = a[sortField.value] != null ? a[sortField.value] : 0;
        var bv = b[sortField.value] != null ? b[sortField.value] : 0;
        return sortDir.value === 'asc' ? av - bv : bv - av;
      });
    });

    function onMark(event) {
      var drawId = event.drawId;
      var judge = event.data.judges[0];
      var fieldType = judge.marks[0].type;
      var markField = "".concat(judge.judgeNumber, "_").concat(fieldType);
      var scoreTypes = ['cutout', 'work', 'course'];
      var preserve = {};
      scoreTypes.forEach(function (t) {
        var key = "".concat(drawId, "_").concat(judge.judgeNumber, "_").concat(t);

        if (pendingMarks[key] && t !== fieldType) {
          if (!preserve[drawId]) preserve[drawId] = [];
          preserve[drawId].push(t);
        }
      });
      handleRowAction(drawId, markDraw(drawId, event.data, Object.keys(preserve).length > 0 ? preserve : null), markField);
    }

    function onFinaliseEvent() {
      return _onFinaliseEvent.apply(this, arguments);
    } // After a successful generation, open the round that was just generated.
    // dbRound is 0-based; URL/tab rounds are 1-based.


    function _onFinaliseEvent() {
      _onFinaliseEvent = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                actionLoading.value = true;
                _context3.next = 3;
                return createCalculator();

              case 3:
                result = _context3.sent;
                actionLoading.value = false;

                if (!(result.type !== 'success')) {
                  _context3.next = 8;
                  break;
                }

                alert.showError(result.message);
                return _context3.abrupt("return");

              case 8:
                router.push("/calculators/".concat(eventId.value));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _onFinaliseEvent.apply(this, arguments);
    }

    function goToGeneratedRound(dbRound, targetEventId) {
      var newRound = dbRound + 1;

      if (targetEventId != null && Number(targetEventId) !== Number(eventId.value)) {
        router.push("/draws/".concat(draftId.value, "/").concat(targetEventId, "/").concat(newRound));
        return;
      } // Combined events: the generated round may live on a sibling/child event
      // (same rule as onRoundChange tab clicks).


      var roundData = rounds.value.find(function (r) {
        return r.index === dbRound;
      });

      if (roundData && roundData.eventId && roundData.eventId !== Number(eventId.value)) {
        router.push("/draws/".concat(draftId.value, "/").concat(roundData.eventId, "/").concat(newRound));
        return;
      }

      if (Number(activeRound.value) !== newRound) {
        setRound(newRound);
      } else {
        fetchAll(newRound);
      }
    }

    function onGenerateNext() {
      return _onGenerateNext.apply(this, arguments);
    }

    function _onGenerateNext() {
      _onGenerateNext = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                actionLoading.value = true;
                _context4.next = 3;
                return generateNext(generateScore.value != null ? Math.max(0, Number(generateScore.value)) : null);

              case 3:
                result = _context4.sent;
                generateScore.value = null;

                if (result && result.message) {
                  if (result.type === 'success') alert.showSuccess(result.message);else alert.showError(result.message);
                }

                if (!(result && result.type === 'success')) {
                  _context4.next = 10;
                  break;
                }

                // Always open the generated round; fall back to the round after the
                // active one when the API response carries no round index.
                goToGeneratedRound(result.round != null ? result.round : activeRound.value);
                _context4.next = 12;
                break;

              case 10:
                _context4.next = 12;
                return refreshDrawsAndMeta();

              case 12:
                actionLoading.value = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _onGenerateNext.apply(this, arguments);
    }

    function onGenerateInto(_x) {
      return _onGenerateInto.apply(this, arguments);
    }

    function _onGenerateInto() {
      _onGenerateInto = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(toEventId) {
        var raw, score, result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                actionLoading.value = true;
                raw = generateScores.value[toEventId];
                score = raw != null ? Math.max(0, Number(raw)) : null;
                _context5.next = 5;
                return generateInto(toEventId, score);

              case 5:
                result = _context5.sent;
                generateScores.value = Object.assign({}, generateScores.value, _defineProperty({}, toEventId, null));

                if (result && result.message) {
                  if (result.type === 'success') alert.showSuccess(result.message);else alert.showError(result.message);
                }

                if (!(result && result.type === 'success')) {
                  _context5.next = 12;
                  break;
                }

                goToGeneratedRound(result.round != null ? result.round : activeRound.value, toEventId);
                _context5.next = 14;
                break;

              case 12:
                _context5.next = 14;
                return refreshDrawsAndMeta();

              case 14:
                actionLoading.value = false;

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _onGenerateInto.apply(this, arguments);
    }

    function onGenerateRunOff() {
      return _onGenerateRunOff.apply(this, arguments);
    }

    function _onGenerateRunOff() {
      _onGenerateRunOff = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6() {
        var result;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                actionLoading.value = true;
                _context6.next = 3;
                return generateRunOff();

              case 3:
                result = _context6.sent;

                if (result && result.message) {
                  if (result.type === 'success') alert.showSuccess(result.message);else alert.showError(result.message);
                }

                if (!(result && result.type === 'success')) {
                  _context6.next = 12;
                  break;
                }

                if (!(result.round != null)) {
                  _context6.next = 10;
                  break;
                }

                goToGeneratedRound(result.round);
                _context6.next = 12;
                break;

              case 10:
                _context6.next = 12;
                return refreshDrawsAndMeta();

              case 12:
                actionLoading.value = false;

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _onGenerateRunOff.apply(this, arguments);
    }

    function onRegenerate() {
      return _onRegenerate.apply(this, arguments);
    }

    function _onRegenerate() {
      _onRegenerate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7() {
        var result;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                showRegenerateConfirm.value = false;
                _context7.next = 3;
                return regenerateFirstRound();

              case 3:
                result = _context7.sent;

                if (result != null && result.message != null) {
                  if (result.type === 'success') {
                    alert.showSuccess(result.message);
                  } else {
                    alert.showError(result.message);
                  }
                }

                if (!(result != null && result.type === 'success')) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 8;
                return refreshDrawsAndMeta();

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _onRegenerate.apply(this, arguments);
    }

    function onPublish() {
      return _onPublish.apply(this, arguments);
    }

    function _onPublish() {
      _onPublish = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8() {
        var result;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                showPublishConfirm.value = false;
                _context8.next = 3;
                return publishRound();

              case 3:
                result = _context8.sent;

                if (result != null && result.message != null) {
                  if (result.type === 'success') {
                    alert.showSuccess(result.message);
                  } else {
                    alert.showError(result.message);
                  }
                }

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _onPublish.apply(this, arguments);
    }

    function onResetTotalScore() {
      return _onResetTotalScore.apply(this, arguments);
    }

    function _onResetTotalScore() {
      _onResetTotalScore = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee9() {
        var result;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                showCleanSlateConfirm.value = false;
                _context9.next = 3;
                return resetTotalScore();

              case 3:
                result = _context9.sent;

                if (result != null && result.message != null) {
                  if (result.type === 'success') {
                    alert.showSuccess(result.message);
                  } else {
                    alert.showError(result.message);
                  }
                }

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
      return _onResetTotalScore.apply(this, arguments);
    }

    function onResendNotifications() {
      return _onResendNotifications.apply(this, arguments);
    }

    function _onResendNotifications() {
      _onResendNotifications = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee10() {
        var result;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return resendNotifications();

              case 2:
                result = _context10.sent;

                if (result != null && result.message != null) {
                  if (result.type === 'success') {
                    alert.showSuccess(result.message);
                  } else {
                    alert.showError(result.message);
                  }
                }

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
      return _onResendNotifications.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(showSwapNominations, function (val) {
      if (val) {
        swapFrom.value = null;
        swapTo.value = null;
        fetchSwapCandidates();
      }
    });

    function onSwap() {
      return _onSwap.apply(this, arguments);
    }

    function _onSwap() {
      _onSwap = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee11() {
        var result;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(!swapFrom.value || !swapTo.value)) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt("return");

              case 2:
                if (!(swapFrom.value.id === swapTo.value.id)) {
                  _context11.next = 4;
                  break;
                }

                return _context11.abrupt("return");

              case 4:
                _context11.next = 6;
                return swapDraws({
                  draw_from: swapFrom.value.id,
                  draw_to: swapTo.value.id
                });

              case 6:
                result = _context11.sent;

                if (result != null && result.message != null) {
                  if (result.type === 'success') {
                    alert.showSuccess(result.message);
                    showSwapNominations.value = false;
                  } else {
                    alert.showError(result.message);
                  }
                }

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
      return _onSwap.apply(this, arguments);
    }

    function onRefund(_x2) {
      return _onRefund.apply(this, arguments);
    }

    function _onRefund() {
      _onRefund = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee12(refundType) {
        var result;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                refundLoading.value = true;
                _context12.next = 3;
                return refundDraws(refundType);

              case 3:
                result = _context12.sent;
                refundLoading.value = false;
                showRefundConfirm.value = false;

                if (result != null && result.message != null) {
                  if (result.type === 'success') {
                    alert.showSuccess(result.message);
                  } else {
                    alert.showError(result.message);
                  }
                }

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
      return _onRefund.apply(this, arguments);
    }

    function onRoundChange(round) {
      if (loading.value || actionLoading.value || isMarking.value) return;
      var roundData = rounds.value.find(function (r) {
        return r.index === round - 1;
      });

      if (roundData && roundData.eventId && roundData.eventId !== Number(eventId.value)) {
        router.push("/draws/".concat(draftId.value, "/").concat(roundData.eventId, "/").concat(round));
        return;
      }

      setRound(round);
    }

    function doScratch(draw, notify) {
      var status = draw.is_active ? 'scratched' : 'accepted';
      handleRowAction(draw.id, updateStatus(draw.id, {
        status: status,
        event_id: eventId.value,
        notify: notify
      }));
    }

    function onScratch(draw) {
      if (draw.is_active && showNotificationsModal.value) {
        pendingScratchDraw.value = draw;
        showScratchConfirm.value = true;
      } else {
        doScratch(draw, false);
      }
    }

    function onScratchConfirm(notify) {
      var draw = pendingScratchDraw.value;
      showScratchConfirm.value = false;
      pendingScratchDraw.value = null;
      if (draw) doScratch(draw, notify);
    }

    function onDragEnd(evt) {
      if (evt.oldIndex === evt.newIndex) return;
      var list = filteredDraws.value;
      var movedDraw = list[evt.oldIndex];
      if (movedDraw == null) return;
      var targetDraw = list[evt.newIndex];
      if (targetDraw == null) return;

      if (showNotificationsModal.value) {
        pendingMoveAction.value = {
          kind: 'reorder',
          drawId: movedDraw.id,
          newOrder: targetDraw.order
        };
        showMoveNotifyConfirm.value = true;
      } else {
        handleRowAction(movedDraw.id, reorderDraw(movedDraw.id, targetDraw.order, false));
      }
    }

    function onMoveRequest(evt) {
      if (showNotificationsModal.value) {
        pendingMoveAction.value = {
          kind: 'move',
          drawId: evt.drawId,
          data: evt.data
        };
        showMoveNotifyConfirm.value = true;
      } else {
        handleRowAction(evt.drawId, moveDraw(evt.drawId, _objectSpread({}, evt.data, {
          notify: false
        })));
      }
    }

    function onMoveNotifyConfirm(notify) {
      var action = pendingMoveAction.value;
      showMoveNotifyConfirm.value = false;
      pendingMoveAction.value = null;
      if (!action) return;

      if (action.kind === 'reorder') {
        handleRowAction(action.drawId, reorderDraw(action.drawId, action.newOrder, notify));
      } else {
        handleRowAction(action.drawId, moveDraw(action.drawId, _objectSpread({}, action.data, {
          notify: notify
        })));
      }
    }

    var refundPollTimer = null;

    function stopRefundPolling() {
      if (refundPollTimer) {
        clearInterval(refundPollTimer);
        refundPollTimer = null;
      }
    }

    function startRefundPolling() {
      stopRefundPolling();
      refundPollTimer = setInterval(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchRefundStatus();

              case 2:
                if (refundQueueNotEmpty.value) {
                  _context.next = 6;
                  break;
                }

                stopRefundPolling();
                _context.next = 6;
                return refreshDrawsAndMeta();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), 5000);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(refundQueueNotEmpty, function (val) {
      if (val) startRefundPolling();else stopRefundPolling();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(activeRound, function () {
      // Add/Restore and Swap forms hold selections/options scoped to the round they were
      // opened in (member/horse search, empty slots, swap candidates) — stale once the round
      // changes, so close them; they refetch fresh on next open.
      showAddNomination.value = false;
      showSwapNominations.value = false;
      var target = "/draws/".concat(draftId.value, "/").concat(eventId.value, "/").concat(activeRound.value);
      if (vm.proxy.$route.path !== target) router.replace(target);
      fetchAll(activeRound.value);
    }); // Component instance is reused when only route params change (cross-event
    // navigation from round tabs or generate-into) — re-sync state manually

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(eventId, function (val) {
      if (val == null) return;
      showAddNomination.value = false;
      showSwapNominations.value = false;
      var urlRound = Number(vm.proxy.$route.params.round) || 1;

      if (activeRound.value !== urlRound) {
        activeRound.value = urlRound;
      } else {
        fetchAll(activeRound.value);
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(redirectTo, function (val) {
      if (val == null) return;

      if (val.path) {
        router.push(val.path).then(function () {
          if (val.message) __WEBPACK_IMPORTED_MODULE_14__store_EventBus__["a" /* default */].$emit('show-success', val.message);
        });
      } else if (val.round) {
        if (val.message) alert.showError(val.message);
        activeRound.value = val.round;
      }
    });
    var loadMoreTrigger = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var loadMoreObserver = null;
    var observingTrigger = false; // Re-arm the observer only on a genuine scroll event, and unobserve as
    // soon as it fires — otherwise, right after a page is appended, the
    // sentinel can still sit inside rootMargin and the observer re-fires
    // immediately (chain-loading extra pages without the user scrolling).

    function armLoadMoreObserver() {
      if (loadMoreObserver == null || loadMoreTrigger.value == null || observingTrigger || !hasMore.value) return;
      loadMoreObserver.observe(loadMoreTrigger.value);
      observingTrigger = true;
    } // Appending rows below can otherwise shift the page (button/spinner
    // layout change, draggable re-render) — pin the scroll position so the
    // user keeps looking at exactly the same content they were on.


    function loadMoreKeepingScroll() {
      return _loadMoreKeepingScroll.apply(this, arguments);
    }

    function _loadMoreKeepingScroll() {
      _loadMoreKeepingScroll = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee13() {
        var scrollY;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                scrollY = window.scrollY;
                _context13.next = 3;
                return loadMore();

              case 3:
                _context13.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])();

              case 5:
                window.scrollTo(window.scrollX, scrollY);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));
      return _loadMoreKeepingScroll.apply(this, arguments);
    }

    function onHttpError(message) {
      alert.showError(message);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      fetchAll(activeRound.value);

      if (loadMoreTrigger.value != null) {
        loadMoreObserver = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          loadMoreObserver.unobserve(loadMoreTrigger.value);
          observingTrigger = false;
          if (hasMore.value && !loadingMore.value) loadMoreKeepingScroll();
        }, {
          root: null,
          threshold: 0
        });
        armLoadMoreObserver();
        window.addEventListener('scroll', armLoadMoreObserver, {
          passive: true
        });
      }

      __WEBPACK_IMPORTED_MODULE_14__store_EventBus__["a" /* default */].$on('http-error', onHttpError);
      document.addEventListener('click', closeEventSwitch);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      if (loadMoreObserver != null) loadMoreObserver.disconnect();
      window.removeEventListener('scroll', armLoadMoreObserver);
      __WEBPACK_IMPORTED_MODULE_14__store_EventBus__["a" /* default */].$off('http-error', onHttpError);
      document.removeEventListener('click', closeEventSwitch);
      stopRefundPolling();
    });
    var downloadingPrint = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var downloadingCsv = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function downloadPrint(_x3) {
      return _downloadPrint.apply(this, arguments);
    }

    function _downloadPrint() {
      _downloadPrint = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee14(type) {
        var res, blobUrl;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(downloadingPrint.value != null)) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt("return");

              case 2:
                downloadingPrint.value = type;
                _context14.prev = 3;
                _context14.next = 6;
                return __WEBPACK_IMPORTED_MODULE_13__services_api_draws__["a" /* default */].printPdf(eventId.value, activeRound.value, type);

              case 6:
                res = _context14.sent;
                blobUrl = URL.createObjectURL(new Blob([res.data], {
                  type: 'application/pdf'
                }));
                window.open(blobUrl, '_blank');
                _context14.next = 14;
                break;

              case 11:
                _context14.prev = 11;
                _context14.t0 = _context14["catch"](3);
                alert.showError('Failed to generate PDF.');

              case 14:
                _context14.prev = 14;
                downloadingPrint.value = null;
                showPrintMenu.value = false;
                return _context14.finish(14);

              case 18:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[3, 11, 14, 18]]);
      }));
      return _downloadPrint.apply(this, arguments);
    }

    function downloadCsv() {
      return _downloadCsv.apply(this, arguments);
    }

    function _downloadCsv() {
      _downloadCsv = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee15() {
        var response, url, link;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!downloadingCsv.value) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return");

              case 2:
                downloadingCsv.value = true;
                _context15.prev = 3;
                _context15.next = 6;
                return __WEBPACK_IMPORTED_MODULE_13__services_api_draws__["a" /* default */].exportCsv(eventId.value, activeRound.value);

              case 6:
                response = _context15.sent;
                url = URL.createObjectURL(new Blob([response.data], {
                  type: 'text/csv'
                }));
                link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'draws.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                _context15.next = 20;
                break;

              case 17:
                _context15.prev = 17;
                _context15.t0 = _context15["catch"](3);
                alert.showError('Failed to download CSV.');

              case 20:
                _context15.prev = 20;
                downloadingCsv.value = false;
                return _context15.finish(20);

              case 23:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[3, 17, 20, 23]]);
      }));
      return _downloadCsv.apply(this, arguments);
    }

    function onPositiveIntKeydown(e) {
      var allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'];
      if (!allowed.includes(e.key) && !/^\d$/.test(e.key)) e.preventDefault();
    }

    return {
      alert: alert,
      draftId: draftId,
      eventId: eventId,
      activeRound: activeRound,
      search: search,
      showConfirm: showConfirm,
      showAddNomination: showAddNomination,
      showSwapNominations: showSwapNominations,
      rounds: rounds,
      roundTabItems: roundTabItems,
      draws: draws,
      emptyDrawsOrders: emptyDrawsOrders,
      emptySlots: emptySlots,
      swapCandidatesLoading: swapCandidatesLoading,
      swapFrom: swapFrom,
      swapTo: swapTo,
      swapOptions: swapOptions,
      showPrintMenu: showPrintMenu,
      showRefundConfirm: showRefundConfirm,
      refundLoading: refundLoading,
      existScratchedDraw: existScratchedDraw,
      draftEvents: draftEvents,
      refundQueueNotEmpty: refundQueueNotEmpty,
      unpublishedDrawsCount: unpublishedDrawsCount,
      paymentMethods: paymentMethods,
      disabledPaymentMethods: disabledPaymentMethods,
      loading: loading,
      loadingMore: loadingMore,
      hasMore: hasMore,
      loadMoreTrigger: loadMoreTrigger,
      loadMoreKeepingScroll: loadMoreKeepingScroll,
      eventName: eventName,
      judgesNum: judgesNum,
      displayEventName: displayEventName,
      showEventSwitch: showEventSwitch,
      eventSwitchTarget: eventSwitchTarget,
      nomMember: nomMember,
      nomHorse: nomHorse,
      nomPlace: nomPlace,
      nomEvent: nomEvent,
      nomMemberOptions: nomMemberOptions,
      nomHorseOptions: nomHorseOptions,
      nomMemberLoading: nomMemberLoading,
      nomMemberSearched: nomMemberSearched,
      nomHorseLoading: nomHorseLoading,
      nomSubmitting: nomSubmitting,
      nomPlaceOptions: nomPlaceOptions,
      nomEventOptions: nomEventOptions,
      showEventSelect: showEventSelect,
      isEventSelectIgnored: isEventSelectIgnored,
      nomEventHelpText: nomEventHelpText,
      generateLabel: generateLabel,
      currentRoundType: currentRoundType,
      isFinalRound: isFinalRound,
      canResetTotalScore: canResetTotalScore,
      hasTiedWinners: hasTiedWinners,
      isCombinedNotSplit: isCombinedNotSplit,
      childEvents: childEvents,
      isParentSplit: isParentSplit,
      finalEvent: finalEvent,
      finalRoundExists: finalRoundExists,
      calculatorId: calculatorId,
      calculator: calculator,
      lastRoundIndex: lastRoundIndex,
      showRunOffPanel: showRunOffPanel,
      showPublishConfirm: showPublishConfirm,
      showRegenerateConfirm: showRegenerateConfirm,
      showCleanSlateConfirm: showCleanSlateConfirm,
      onResetTotalScore: onResetTotalScore,
      generateScore: generateScore,
      generateScores: generateScores,
      onFinaliseEvent: onFinaliseEvent,
      onGenerateNext: onGenerateNext,
      onGenerateInto: onGenerateInto,
      onPositiveIntKeydown: onPositiveIntKeydown,
      showScratchConfirm: showScratchConfirm,
      onRoundChange: onRoundChange,
      onScratch: onScratch,
      onScratchConfirm: onScratchConfirm,
      showMoveNotifyConfirm: showMoveNotifyConfirm,
      onMoveRequest: onMoveRequest,
      onMoveNotifyConfirm: onMoveNotifyConfirm,
      isFirstRoundInsert: isFirstRoundInsert,
      addNomButtonLabel: addNomButtonLabel,
      nomMemberEmptyMessage: nomMemberEmptyMessage,
      onMemberSearch: onMemberSearch,
      onMemberDropdownOpen: onMemberDropdownOpen,
      onMemberSelect: onMemberSelect,
      onAddNomination: onAddNomination,
      filteredDraws: filteredDraws,
      commitOptions: commitOptions,
      rowAlerts: rowAlerts,
      actionLoading: actionLoading,
      isMarking: isMarking,
      pendingMarks: pendingMarks,
      handleRowAction: handleRowAction,
      sortField: sortField,
      sortDir: sortDir,
      toggleSort: toggleSort,
      isNextRoundGenerated: isNextRoundGenerated,
      onMark: onMark,
      onGenerateRunOff: onGenerateRunOff,
      onRegenerate: onRegenerate,
      onPublish: onPublish,
      onResendNotifications: onResendNotifications,
      onSwap: onSwap,
      onRefund: onRefund,
      onDragEnd: onDragEnd,
      setRound: setRound,
      markDraw: markDraw,
      deleteDraw: deleteDraw,
      moveDraw: moveDraw,
      swapDraws: swapDraws,
      cleanSlate: cleanSlate,
      publishRound: publishRound,
      updateStatus: updateStatus,
      loadMore: loadMore,
      refreshDraws: refreshDraws,
      refreshDrawsAndMeta: refreshDrawsAndMeta,
      reorderDraw: reorderDraw,
      updateCommit: updateCommit,
      togglePaymentStatus: togglePaymentStatus,
      scoreLimits: scoreLimits,
      downloadPrint: downloadPrint,
      downloadCsv: downloadCsv,
      downloadingPrint: downloadingPrint,
      downloadingCsv: downloadingCsv
    };
  }
}));

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormAlert__ = __webpack_require__(1127);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DrawRow',
  components: {
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_2__components_FormAlert__["a" /* default */]
  },
  props: {
    draw: {
      type: Object,
      required: true
    },
    roundType: {
      type: Number,
      default: 1
    },
    pendingMarks: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    emptySlots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    commitOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    scoreLimits: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    judgesNum: {
      type: Number,
      default: 1
    },
    alertMessage: {
      type: String,
      default: null
    },
    alertType: {
      type: String,
      default: 'warning'
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var judgeInputs = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({});
    var dirtyFields = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({});

    function judgeNumbersList() {
      var count = Math.max(1, props.judgesNum);
      return Array.from({
        length: count
      }, function (_, i) {
        return i + 1;
      });
    }

    function ensureJudgeSlot(judgeNumber) {
      if (judgeInputs[judgeNumber] == null) Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["m" /* set */])(judgeInputs, judgeNumber, {});
    }

    function findJudgeScore(draw, judgeNumber) {
      var scores = draw.judge_scores;
      if (!Array.isArray(scores)) return null;
      return scores.find(function (s) {
        return s.judge_number === judgeNumber;
      }) || null;
    } // Rounds to 2dp for precision but drops trailing zeros (34.00 -> "34", 34.50 -> "34.5"),
    // matching the monolith's `(float)`/`parseFloat(...).toString()` display behaviour.


    function toDisplayScore(value) {
      return value == null ? null : String(parseFloat(Number(value).toFixed(2)));
    }

    function syncJudgeValues(draw, limits, numbers) {
      numbers.forEach(function (judgeNumber) {
        ensureJudgeSlot(judgeNumber);
        var existing = findJudgeScore(draw, judgeNumber);
        limits.forEach(function (limit) {
          var key = "".concat(judgeNumber, "_").concat(limit.type);
          if (dirtyFields[key]) return;
          var val = '';

          if (existing != null && existing[limit.type] != null) {
            val = toDisplayScore(existing[limit.type]);
          } else if (judgeNumber === 1 && numbers.length === 1 && draw[limit.type] != null) {
            val = toDisplayScore(draw[limit.type]);
          }

          Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["m" /* set */])(judgeInputs[judgeNumber], limit.type, val);
        });
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.draw;
    }, function (draw) {
      syncJudgeValues(draw, props.scoreLimits, judgeNumbersList());
    }, {
      immediate: true,
      deep: true
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return [props.scoreLimits, props.judgesNum];
    }, function () {
      syncJudgeValues(props.draw, props.scoreLimits, judgeNumbersList());
    });

    function judgeValue(judgeNumber, type) {
      return judgeInputs[judgeNumber] != null && judgeInputs[judgeNumber][type] != null ? judgeInputs[judgeNumber][type] : '';
    }

    var memberName = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var m = props.draw.member;
      if (m == null) return '';
      return "".concat(m.first_name, " ").concat(m.last_name);
    });
    var eventLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var nom = props.draw.nomination;
      if (nom == null) return null;
      if (nom.comb_nomination_id != null) return 'All';

      if (nom.current_event_id != null) {
        return nom.event_name != null ? nom.event_name : String(nom.current_event_id);
      }

      return nom.event_name != null ? nom.event_name : null;
    });
    var hasMember = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.draw.member != null;
    });
    var totalLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (props.roundType === 3) return 'Final score';
      if (props.roundType === 4) return 'Run-off score';
      return 'Round score';
    });

    function formatScore(value) {
      return value != null ? toDisplayScore(value) : '0';
    }

    var scoreDisabled = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return !props.draw.user_id || !props.draw.is_active || !props.draw.is_published;
    });

    function isFieldPending(judgeNumber, fieldType) {
      var key = "".concat(props.draw.id, "_").concat(judgeNumber, "_").concat(fieldType);
      return !!props.pendingMarks[key];
    }

    var isPaid = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var nom = props.draw.nomination;
      return nom != null && nom.is_paid;
    });
    var moveOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.emptySlots.map(function (s) {
        return {
          value: s.id,
          label: String(s.order)
        };
      });
    });
    var commitOptionsWithNull = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return [{
        value: null,
        label: 'Payment type'
      }].concat(props.commitOptions);
    });
    var currentCommitOption = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var nom = props.draw.nomination;
      var val = nom != null ? nom.commit : null;
      return commitOptionsWithNull.value.find(function (o) {
        return o.value === val;
      }) || commitOptionsWithNull.value[0];
    });

    function onCommitChange(option) {
      if (option == null) return;
      emit('commit', {
        nominationId: props.draw.nomination_id,
        commit: option.value
      });
    }

    function onMoveSelect(option) {
      if (option == null) return;
      emit('move', {
        drawId: props.draw.id,
        data: {
          move_on: option.value,
          current_order: props.draw.order,
          event_id: props.draw.event_id,
          round_id: props.draw.round
        }
      });
    }

    function maskScore(judgeNumber, limit, event) {
      var el = event.target;
      var val = el.value.replace(/[^0-9.]/g, '');
      var parts = val.split('.');
      if (parts.length > 2) val = "".concat(parts[0], ".").concat(parts.slice(1).join(''));

      if (parts.length === 2 && parts[1].length > 2) {
        val = "".concat(parts[0], ".").concat(parts[1].substring(0, 2));
      }

      if (val !== '' && val !== '.' && Number(val) > limit.max) {
        val = String(limit.max);
      }

      if (el.value !== val) {
        el.value = val;
      }

      ensureJudgeSlot(judgeNumber);
      Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["m" /* set */])(judgeInputs[judgeNumber], limit.type, val);
      dirtyFields["".concat(judgeNumber, "_").concat(limit.type)] = true;
    }

    function emitMark(judgeNumber, limit, event) {
      var val = event.target.value.trim();
      var score = val !== '' ? Number(val) : null;
      dirtyFields["".concat(judgeNumber, "_").concat(limit.type)] = false;
      emit('mark', {
        drawId: props.draw.id,
        data: {
          judges: [{
            judgeNumber: judgeNumber,
            marks: [{
              type: limit.type,
              score: score
            }]
          }]
        }
      });
    }

    function averagePreviewValues() {
      var result = {};
      props.scoreLimits.forEach(function (limit) {
        var nums = judgeNumbersList().map(function (judgeNumber) {
          var v = judgeValue(judgeNumber, limit.type);
          return v === '' || v == null ? 0 : Number(v);
        });
        var avg = nums.length > 0 ? nums.reduce(function (a, b) {
          return a + b;
        }, 0) / nums.length : 0;
        result[limit.type] = toDisplayScore(avg);
      });
      return result;
    }

    function orderedScoreInputs() {
      var containers = Array.from(document.querySelectorAll('.draws-table__col.--inputs'));
      return containers.reduce(function (result, container) {
        var inputs = Array.from(container.querySelectorAll('[data-score-input]:not([disabled])'));
        inputs.sort(function (a, b) {
          var judgeDiff = Number(a.dataset.judgeIndex) - Number(b.dataset.judgeIndex);
          if (judgeDiff !== 0) return judgeDiff;
          return Number(a.dataset.limitIndex) - Number(b.dataset.limitIndex);
        });
        return result.concat(inputs);
      }, []);
    }

    function focusNextScoreInput(currentEl, reverse, selectAll) {
      var all = orderedScoreInputs();
      var idx = all.indexOf(currentEl);
      if (idx === -1) return;
      var next = reverse ? all[idx - 1] : all[idx + 1];

      if (next) {
        next.focus();
        if (selectAll) next.select();
      }
    }

    function onScoreKeydown(event) {
      var key = event.key,
          shiftKey = event.shiftKey;
      if (key !== 'Enter' && key !== 'Tab') return;

      if (key === 'Tab' && shiftKey) {
        event.preventDefault();
        focusNextScoreInput(event.target, true, true);
        return;
      }

      event.preventDefault();

      if (key === 'Enter') {
        event.target.blur();
      }

      focusNextScoreInput(event.target, false, key === 'Tab');
    }

    return {
      memberName: memberName,
      hasMember: hasMember,
      totalLabel: totalLabel,
      formatScore: formatScore,
      eventLabel: eventLabel,
      scoreDisabled: scoreDisabled,
      isFieldPending: isFieldPending,
      isPaid: isPaid,
      moveOptions: moveOptions,
      commitOptionsWithNull: commitOptionsWithNull,
      currentCommitOption: currentCommitOption,
      onCommitChange: onCommitChange,
      onMoveSelect: onMoveSelect,
      maskScore: maskScore,
      emitMark: emitMark,
      onScoreKeydown: onScoreKeydown,
      judgeNumbersList: judgeNumbersList,
      judgeValue: judgeValue,
      averagePreviewValues: averagePreviewValues
    };
  }
}));

/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1390);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("0660c492", content, true, {});

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1094);
exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".draws-event-switch{position:relative;display:inline-block}.draws-event-switch__btn{vertical-align:middle;font-size:1.5rem}.draws-event-switch__menu{position:absolute;left:0;top:calc(100% + 4px);z-index:1000;min-width:280px;max-height:340px;overflow-y:auto;margin:0;padding:0;list-style:none;background-color:#fff;box-shadow:0 1px 4px #000}.draws-event-switch__menu a{display:block;padding:10px 15px;font-size:1rem;white-space:nowrap}.draws-event-switch__menu a:hover{background-color:var(--gray-100)}.draws-event-switch__item--active{font-weight:700}.draws-dashboard__warn-icon{display:inline-block;background-image:url(" + escape(__webpack_require__(1095)) + ");background-position:-34px 0;width:32px;height:28px;vertical-align:middle;margin-right:.4rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Draws/View/DrawsEventView.vue"],"names":[],"mappings":"AACA,oBACE,kBAAmB,AACnB,oBAAsB,CACvB,AACD,yBACE,sBAAuB,AACvB,gBAAkB,CACnB,AACD,0BACE,kBAAmB,AACnB,OAAQ,AACR,qBAAsB,AACtB,aAAc,AACd,gBAAiB,AACjB,iBAAkB,AAClB,gBAAiB,AACjB,SAAU,AACV,UAAW,AACX,gBAAiB,AACjB,sBAAuB,AACvB,yBAA2B,CAC5B,AACD,4BACE,cAAe,AACf,kBAAmB,AACnB,eAAgB,AAChB,kBAAoB,CACrB,AACD,kCACE,gCAAkC,CACnC,AACD,kCACE,eAAiB,CAClB,AACD,4BACE,qBAAsB,AACtB,+CAAkD,AAClD,4BAA+B,AAC/B,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,kBAAqB,CACtB","file":"DrawsEventView.vue","sourcesContent":["\n.draws-event-switch {\n  position: relative;\n  display: inline-block;\n}\n.draws-event-switch__btn {\n  vertical-align: middle;\n  font-size: 1.5rem;\n}\n.draws-event-switch__menu {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 4px);\n  z-index: 1000;\n  min-width: 280px;\n  max-height: 340px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background-color: #fff;\n  box-shadow: 0 1px 4px #000;\n}\n.draws-event-switch__menu a {\n  display: block;\n  padding: 10px 15px;\n  font-size: 1rem;\n  white-space: nowrap;\n}\n.draws-event-switch__menu a:hover {\n  background-color: var(--gray-100);\n}\n.draws-event-switch__item--active {\n  font-weight: 700;\n}\n.draws-dashboard__warn-icon {\n  display: inline-block;\n  background-image: url('~@/assets/img/sprite.png');\n  background-position: -34px 0px;\n  width: 32px;\n  height: 28px;\n  vertical-align: middle;\n  margin-right: 0.4rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDrawsEventView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_draws__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_calculators__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





function useDrawsEventView(eventIdInput, draftIdInput, initialRound) {
  var eventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(eventIdInput);
  });
  var draftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(draftIdInput);
  });
  var meta = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var draws = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var nextCursor = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var hasMore = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loadingMore = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var emptySlots = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var swapCandidates = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var swapCandidatesLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var eventInfo = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var redirectTo = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var activeRound = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(initialRound != null ? Number(initialRound) : 1);
  var draft = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.draft : null;
  });
  var eventName = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return eventInfo.value != null && eventInfo.value.event != null ? eventInfo.value.event.name : '';
  });
  var judgesNum = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return eventInfo.value != null && eventInfo.value.event != null ? eventInfo.value.event.judgesNum : 1;
  });
  var autoSendTexts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return draft.value != null ? draft.value.auto_send_texts : false;
  });
  var rounds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null && meta.value.rounds != null ? meta.value.rounds : [];
  });
  var eventRoundsNum = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.eventRoundsNum : 0;
  });
  var lastRoundIndex = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.lastRoundIndex : 0;
  });
  var calculatorId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.calculatorId : null;
  });
  var calculator = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.calculator : null;
  });
  var finalRoundExists = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.finalRoundExists : false;
  });
  var isParentSplit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.isParentSplit : false;
  });
  var isBrotherCombSplit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.isBrotherCombSplit : false;
  });
  var parentEventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.parentEventId : null;
  });
  var childEventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.childEventId : null;
  });
  var childrenEventListWithParent = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null && meta.value.childrenEventListWithParent != null ? meta.value.childrenEventListWithParent : [];
  });
  var finalEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.finalEvent : null;
  });
  var allSiblingsHaveDraws = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.allSiblingsHaveDraws : true;
  });
  var existScratchedDraw = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.existScratchedDraw : false;
  });
  var draftEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null && meta.value.draftEvents != null ? meta.value.draftEvents : [];
  });
  var refundQueueNotEmpty = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var paymentMethods = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null && meta.value.paymentMethods != null ? meta.value.paymentMethods : [];
  });
  var disabledPaymentMethods = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null && meta.value.disabledPaymentMethods != null ? meta.value.disabledPaymentMethods : [];
  });
  var scoreLimits = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null && meta.value.scoreLimits != null ? meta.value.scoreLimits : [];
  });
  var roundMeta = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return meta.value != null ? meta.value.roundMeta : null;
  });
  var emptyDrawsOrders = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return roundMeta.value != null && roundMeta.value.emptyDrawsOrders != null ? roundMeta.value.emptyDrawsOrders : [];
  });
  var unpublishedDrawsCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return roundMeta.value != null ? roundMeta.value.unpublishedDrawsCount : 0;
  });
  var showNotificationsModal = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return roundMeta.value != null ? roundMeta.value.showNotificationsModal : false;
  });
  var isNextRoundGenerated = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return roundMeta.value != null ? roundMeta.value.isNextRoundGenerated : false;
  });
  var showRunOffPanel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return roundMeta.value != null ? roundMeta.value.showRunOffPanel : false;
  }); // Starts from the value loaded with roundMeta, then kept fresh after each score
  // save via refreshTieCheck() — a full eventDrawsMeta refetch is too heavy to run
  // after every mark, so this hits a dedicated lightweight endpoint instead.

  var hasTiedWinners = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(roundMeta, function (val) {
    hasTiedWinners.value = val != null ? Boolean(val.hasTiedWinners) : false;
  });

  function refreshTieCheck(_x) {
    return _refreshTieCheck.apply(this, arguments);
  }

  function _refreshTieCheck() {
    _refreshTieCheck = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(round) {
      var r, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              r = round != null ? round : activeRound.value;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getTieCheck(eventId.value, r);

            case 4:
              res = _context.sent;
              hasTiedWinners.value = Boolean(res.data.data.hasTiedWinners);
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _refreshTieCheck.apply(this, arguments);
  }

  function fetchInfo() {
    return _fetchInfo.apply(this, arguments);
  }

  function _fetchInfo() {
    _fetchInfo = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getEventInfo(eventId.value);

            case 3:
              res = _context2.sent;
              eventInfo.value = res.data.data;
              return _context2.abrupt("return", eventInfo.value);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              eventInfo.value = null;
              return _context2.abrupt("return", null);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return _fetchInfo.apply(this, arguments);
  }

  function fetchRoundCheck(_x2) {
    return _fetchRoundCheck.apply(this, arguments);
  }

  function _fetchRoundCheck() {
    _fetchRoundCheck = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(round) {
      var res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getRoundCheck(eventId.value, round);

            case 3:
              res = _context3.sent;
              return _context3.abrupt("return", res.data.data);

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", null);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return _fetchRoundCheck.apply(this, arguments);
  }

  function fetchMeta(_x3) {
    return _fetchMeta.apply(this, arguments);
  }

  function _fetchMeta() {
    _fetchMeta = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(round) {
      var r, res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              r = round != null ? round : activeRound.value;
              _context4.prev = 1;
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getEventMeta(eventId.value, {
                round: r
              });

            case 4:
              res = _context4.sent;
              meta.value = res.data.data;
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              meta.value = null;

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return _fetchMeta.apply(this, arguments);
  }

  function fetchDraws(_x4, _x5) {
    return _fetchDraws.apply(this, arguments);
  }

  function _fetchDraws() {
    _fetchDraws = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(round, params) {
      var r, query, res, resMeta;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              r = round != null ? round : activeRound.value;
              query = Object.assign({
                sort: 'order',
                direction: 'asc'
              }, params);
              _context5.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getRoundDraws(eventId.value, r, query);

            case 5:
              res = _context5.sent;
              draws.value = res.data.data;
              resMeta = res.data.meta;
              nextCursor.value = resMeta != null ? resMeta.next_cursor : null;
              hasMore.value = resMeta != null ? resMeta.has_more : false;
              _context5.next = 17;
              break;

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](0);
              draws.value = [];
              nextCursor.value = null;
              hasMore.value = false;

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 12]]);
    }));
    return _fetchDraws.apply(this, arguments);
  }

  function fetchEmptySlots(_x6) {
    return _fetchEmptySlots.apply(this, arguments);
  }

  function _fetchEmptySlots() {
    _fetchEmptySlots = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(round) {
      var r, res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              r = round != null ? round : activeRound.value;
              _context6.prev = 1;
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getEmptySlots(eventId.value, r);

            case 4:
              res = _context6.sent;
              emptySlots.value = res.data.data;
              _context6.next = 11;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              emptySlots.value = [];

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 8]]);
    }));
    return _fetchEmptySlots.apply(this, arguments);
  }

  function fetchSwapCandidates() {
    return _fetchSwapCandidates.apply(this, arguments);
  }

  function _fetchSwapCandidates() {
    _fetchSwapCandidates = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7() {
      var res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              swapCandidatesLoading.value = true;
              _context7.prev = 1;
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].swapCandidates(eventId.value, activeRound.value);

            case 4:
              res = _context7.sent;
              swapCandidates.value = res.data.data;
              _context7.next = 11;
              break;

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](1);
              swapCandidates.value = [];

            case 11:
              _context7.prev = 11;
              swapCandidatesLoading.value = false;
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 8, 11, 14]]);
    }));
    return _fetchSwapCandidates.apply(this, arguments);
  }

  function loadMore() {
    return _loadMore.apply(this, arguments);
  }

  function _loadMore() {
    _loadMore = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8() {
      var res, resMeta;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!hasMore.value || nextCursor.value == null || loadingMore.value)) {
                _context8.next = 2;
                break;
              }

              return _context8.abrupt("return");

            case 2:
              loadingMore.value = true;
              _context8.prev = 3;
              _context8.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getRoundDraws(eventId.value, activeRound.value, {
                sort: 'order',
                direction: 'asc',
                cursor: nextCursor.value
              });

            case 6:
              res = _context8.sent;
              draws.value = draws.value.concat(res.data.data);
              resMeta = res.data.meta;
              nextCursor.value = resMeta != null ? resMeta.next_cursor : null;
              hasMore.value = resMeta != null ? resMeta.has_more : false;
              _context8.next = 15;
              break;

            case 13:
              _context8.prev = 13;
              _context8.t0 = _context8["catch"](3);

            case 15:
              _context8.prev = 15;
              loadingMore.value = false;
              return _context8.finish(15);

            case 18:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[3, 13, 15, 18]]);
    }));
    return _loadMore.apply(this, arguments);
  }

  var infoLoaded = false;
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(eventId, function () {
    infoLoaded = false;
  });

  function fetchAll(_x7) {
    return _fetchAll.apply(this, arguments);
  }

  function _fetchAll() {
    _fetchAll = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(round) {
      var r, info, check, firstRound;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              loading.value = true;
              redirectTo.value = null;
              r = round != null ? round : activeRound.value;
              _context9.prev = 3;

              if (infoLoaded) {
                _context9.next = 12;
                break;
              }

              _context9.next = 7;
              return fetchInfo();

            case 7:
              info = _context9.sent;

              if (!(info == null || !info.hasDraws)) {
                _context9.next = 11;
                break;
              }

              redirectTo.value = {
                path: '/draws/dashboard',
                message: 'Round is not generated yet.'
              };
              return _context9.abrupt("return");

            case 11:
              infoLoaded = true;

            case 12:
              _context9.next = 14;
              return fetchRoundCheck(r);

            case 14:
              check = _context9.sent;

              if (!(check == null || !check.roundExists)) {
                _context9.next = 19;
                break;
              }

              firstRound = check != null ? check.firstAvailableRound : null;

              if (firstRound != null && firstRound !== r) {
                redirectTo.value = {
                  round: firstRound,
                  message: 'Round is not generated yet. Redirected to the first available round.'
                };
              } else {
                redirectTo.value = {
                  path: '/draws/dashboard',
                  message: 'Round is not generated yet.'
                };
              }

              return _context9.abrupt("return");

            case 19:
              _context9.next = 21;
              return Promise.all([fetchMeta(r), fetchDraws(r), fetchEmptySlots(r)]);

            case 21:
              _context9.prev = 21;
              loading.value = false;
              return _context9.finish(21);

            case 24:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[3,, 21, 24]]);
    }));
    return _fetchAll.apply(this, arguments);
  }

  function refreshDraws() {
    return _refreshDraws.apply(this, arguments);
  }

  function _refreshDraws() {
    _refreshDraws = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee10() {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return fetchDraws(activeRound.value);

            case 2:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return _refreshDraws.apply(this, arguments);
  }

  function refreshDrawsAndMeta() {
    return _refreshDrawsAndMeta.apply(this, arguments);
  }

  function _refreshDrawsAndMeta() {
    _refreshDrawsAndMeta = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee11() {
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return Promise.all([fetchMeta(activeRound.value), fetchDraws(activeRound.value), fetchEmptySlots(activeRound.value)]);

            case 2:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return _refreshDrawsAndMeta.apply(this, arguments);
  }

  function setRound(index) {
    activeRound.value = index;
  }

  function patchDraws(affected, preserveFields) {
    if (!Array.isArray(affected) || affected.length === 0) return;
    var list = draws.value;
    affected.forEach(function (item) {
      var idx = list.findIndex(function (d) {
        return d.id === item.id;
      });

      if (idx !== -1) {
        if (preserveFields != null && preserveFields[item.id] != null) {
          var fields = preserveFields[item.id];
          var merged = Object.assign({}, item);
          fields.forEach(function (f) {
            merged[f] = list[idx][f];
          });
          list.splice(idx, 1, merged);
        } else {
          list.splice(idx, 1, item);
        }
      } else {
        var maxOrder = list.reduce(function (max, d) {
          return d.order > max ? d.order : max;
        }, -1);

        if (!hasMore.value || item.order <= maxOrder) {
          list.push(item);
        }
      }
    });
  }

  function extractError(err) {
    var data = err.response != null ? err.response.data : null;
    return data != null && data.message != null ? data.message : 'Something went wrong.';
  }

  function markDraw(_x8, _x9, _x10) {
    return _markDraw.apply(this, arguments);
  }

  function _markDraw() {
    _markDraw = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee12(drawId, data, preserveFields) {
      var res;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].markDraw(drawId, data);

            case 3:
              res = _context12.sent;
              patchDraws(res.data.data, preserveFields);
              return _context12.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](0);
              return _context12.abrupt("return", {
                message: extractError(_context12.t0),
                type: 'warning'
              });

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[0, 8]]);
    }));
    return _markDraw.apply(this, arguments);
  }

  function deleteDraw(_x11) {
    return _deleteDraw.apply(this, arguments);
  }

  function _deleteDraw() {
    _deleteDraw = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee13(drawId) {
      var res;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].deleteDraw(drawId);

            case 3:
              res = _context13.sent;
              patchDraws(res.data.data);
              fetchEmptySlots();
              return _context13.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 9:
              _context13.prev = 9;
              _context13.t0 = _context13["catch"](0);
              return _context13.abrupt("return", {
                message: extractError(_context13.t0),
                type: 'warning'
              });

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[0, 9]]);
    }));
    return _deleteDraw.apply(this, arguments);
  }

  function moveDraw(_x12, _x13) {
    return _moveDraw.apply(this, arguments);
  }

  function _moveDraw() {
    _moveDraw = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee14(drawId, data) {
      var res;
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].moveDraw(drawId, data);

            case 3:
              res = _context14.sent;
              patchDraws(res.data.data);
              fetchEmptySlots();
              return _context14.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 9:
              _context14.prev = 9;
              _context14.t0 = _context14["catch"](0);
              return _context14.abrupt("return", {
                message: extractError(_context14.t0),
                type: 'warning'
              });

            case 12:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[0, 9]]);
    }));
    return _moveDraw.apply(this, arguments);
  }

  function swapDraws(_x14) {
    return _swapDraws.apply(this, arguments);
  }

  function _swapDraws() {
    _swapDraws = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee15(data) {
      var res;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].swapDraws(data);

            case 3:
              res = _context15.sent;
              patchDraws(res.data.data);
              return _context15.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 8:
              _context15.prev = 8;
              _context15.t0 = _context15["catch"](0);
              return _context15.abrupt("return", {
                message: extractError(_context15.t0),
                type: 'warning'
              });

            case 11:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[0, 8]]);
    }));
    return _swapDraws.apply(this, arguments);
  }

  function fetchRefundStatus() {
    return _fetchRefundStatus.apply(this, arguments);
  }

  function _fetchRefundStatus() {
    _fetchRefundStatus = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee16() {
      var res, data;
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].refundStatus(eventId.value);

            case 3:
              res = _context16.sent;
              data = res.data.data != null ? res.data.data : {};
              refundQueueNotEmpty.value = data.queueNotEmpty === true;
              _context16.next = 10;
              break;

            case 8:
              _context16.prev = 8;
              _context16.t0 = _context16["catch"](0);

            case 10:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[0, 8]]);
    }));
    return _fetchRefundStatus.apply(this, arguments);
  }

  function refundDraws(_x15) {
    return _refundDraws.apply(this, arguments);
  }

  function _refundDraws() {
    _refundDraws = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee17(refundType) {
      var res;
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              _context17.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].refund(eventId.value, {
                refund_type: refundType
              });

            case 3:
              res = _context17.sent;
              _context17.next = 6;
              return fetchRefundStatus();

            case 6:
              return _context17.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 9:
              _context17.prev = 9;
              _context17.t0 = _context17["catch"](0);
              return _context17.abrupt("return", {
                message: extractError(_context17.t0),
                type: 'warning'
              });

            case 12:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, null, [[0, 9]]);
    }));
    return _refundDraws.apply(this, arguments);
  }

  function cleanSlate(_x16) {
    return _cleanSlate.apply(this, arguments);
  }

  function _cleanSlate() {
    _cleanSlate = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee18(drawIds) {
      var res;
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].cleanSlate({
                draw_ids: drawIds
              });

            case 3:
              res = _context18.sent;
              patchDraws(res.data.data);
              return _context18.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 8:
              _context18.prev = 8;
              _context18.t0 = _context18["catch"](0);
              return _context18.abrupt("return", {
                message: extractError(_context18.t0),
                type: 'warning'
              });

            case 11:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[0, 8]]);
    }));
    return _cleanSlate.apply(this, arguments);
  }

  function publishRound() {
    return _publishRound.apply(this, arguments);
  }

  function _publishRound() {
    _publishRound = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee19() {
      var res;
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].publishRound(eventId.value, activeRound.value);

            case 3:
              res = _context19.sent;
              _context19.next = 6;
              return refreshDrawsAndMeta();

            case 6:
              return _context19.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 9:
              _context19.prev = 9;
              _context19.t0 = _context19["catch"](0);
              return _context19.abrupt("return", {
                message: extractError(_context19.t0),
                type: 'warning'
              });

            case 12:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, null, [[0, 9]]);
    }));
    return _publishRound.apply(this, arguments);
  }

  function resetTotalScore() {
    return _resetTotalScore.apply(this, arguments);
  }

  function _resetTotalScore() {
    _resetTotalScore = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee20() {
      var res;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].resetTotalScore(eventId.value, activeRound.value);

            case 3:
              res = _context20.sent;
              _context20.next = 6;
              return refreshDrawsAndMeta();

            case 6:
              return _context20.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 9:
              _context20.prev = 9;
              _context20.t0 = _context20["catch"](0);
              return _context20.abrupt("return", {
                message: extractError(_context20.t0),
                type: 'warning'
              });

            case 12:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, null, [[0, 9]]);
    }));
    return _resetTotalScore.apply(this, arguments);
  }

  function resendNotifications() {
    return _resendNotifications.apply(this, arguments);
  }

  function _resendNotifications() {
    _resendNotifications = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee21() {
      var res;
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;
              _context21.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].resendNotifications(draftId.value, {
                events_id: [eventId.value],
                members_id: [],
                round: activeRound.value - 1
              });

            case 3:
              res = _context21.sent;
              return _context21.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 7:
              _context21.prev = 7;
              _context21.t0 = _context21["catch"](0);
              return _context21.abrupt("return", {
                message: extractError(_context21.t0),
                type: 'warning'
              });

            case 10:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, null, [[0, 7]]);
    }));
    return _resendNotifications.apply(this, arguments);
  }

  function updateStatus(_x17, _x18) {
    return _updateStatus.apply(this, arguments);
  }

  function _updateStatus() {
    _updateStatus = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee22(drawId, data) {
      var res;
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].updateStatus(drawId, data);

            case 3:
              res = _context22.sent;
              patchDraws(res.data.data.draws);
              if (meta.value != null) meta.value.existScratchedDraw = res.data.data.existScratchedDraw;
              fetchEmptySlots();
              return _context22.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 10:
              _context22.prev = 10;
              _context22.t0 = _context22["catch"](0);
              return _context22.abrupt("return", {
                message: extractError(_context22.t0),
                type: 'warning'
              });

            case 13:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, null, [[0, 10]]);
    }));
    return _updateStatus.apply(this, arguments);
  }

  function regenerateFirstRound() {
    return _regenerateFirstRound.apply(this, arguments);
  }

  function _regenerateFirstRound() {
    _regenerateFirstRound = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee23() {
      var res;
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              _context23.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].regenerateFirstRound(eventId.value);

            case 3:
              res = _context23.sent;
              _context23.next = 6;
              return refreshDrawsAndMeta();

            case 6:
              return _context23.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 9:
              _context23.prev = 9;
              _context23.t0 = _context23["catch"](0);
              return _context23.abrupt("return", {
                message: extractError(_context23.t0),
                type: 'warning'
              });

            case 12:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, null, [[0, 9]]);
    }));
    return _regenerateFirstRound.apply(this, arguments);
  }

  function generateRound(_x19) {
    return _generateRound.apply(this, arguments);
  }

  function _generateRound() {
    _generateRound = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee24(round) {
      var res;
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              _context24.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].generateRound(eventId.value, round);

            case 3:
              res = _context24.sent;
              if (res.data.message) __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('show-success', res.data.message);
              _context24.next = 7;
              return refreshDrawsAndMeta();

            case 7:
              _context24.next = 11;
              break;

            case 9:
              _context24.prev = 9;
              _context24.t0 = _context24["catch"](0);

            case 11:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, null, [[0, 9]]);
    }));
    return _generateRound.apply(this, arguments);
  }

  function generateRunOff() {
    return _generateRunOff.apply(this, arguments);
  }

  function _generateRunOff() {
    _generateRunOff = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee25() {
      var res, data;
      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;
              _context25.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].generateRunOff(eventId.value);

            case 3:
              res = _context25.sent;
              data = res.data.data;
              return _context25.abrupt("return", {
                message: res.data.message || null,
                type: 'success',
                round: data != null && data.round != null ? data.round : null
              });

            case 8:
              _context25.prev = 8;
              _context25.t0 = _context25["catch"](0);
              return _context25.abrupt("return", {
                message: extractError(_context25.t0),
                type: 'warning'
              });

            case 11:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, null, [[0, 8]]);
    }));
    return _generateRunOff.apply(this, arguments);
  }

  function insertDraw(_x20) {
    return _insertDraw.apply(this, arguments);
  }

  function _insertDraw() {
    _insertDraw = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee26(data) {
      var res, resData, deletedIds;
      return regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].insert(eventId.value, data);

            case 3:
              res = _context26.sent;
              resData = res.data.data;
              deletedIds = resData.deleted_ids != null ? resData.deleted_ids : [];

              if (deletedIds.length > 0) {
                draws.value = draws.value.filter(function (d) {
                  return deletedIds.indexOf(d.id) === -1;
                });
              }

              patchDraws(resData.draws);
              fetchEmptySlots();
              return _context26.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 12:
              _context26.prev = 12;
              _context26.t0 = _context26["catch"](0);
              return _context26.abrupt("return", {
                message: extractError(_context26.t0),
                type: 'warning'
              });

            case 15:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26, null, [[0, 12]]);
    }));
    return _insertDraw.apply(this, arguments);
  }

  function restoreDraw(_x21, _x22) {
    return _restoreDraw.apply(this, arguments);
  }

  function _restoreDraw() {
    _restoreDraw = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee27(drawId, data) {
      var res;
      return regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;
              _context27.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].restore(drawId, data);

            case 3:
              res = _context27.sent;
              _context27.next = 6;
              return refreshDrawsAndMeta();

            case 6:
              return _context27.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 9:
              _context27.prev = 9;
              _context27.t0 = _context27["catch"](0);
              return _context27.abrupt("return", {
                message: extractError(_context27.t0),
                type: 'warning'
              });

            case 12:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27, null, [[0, 9]]);
    }));
    return _restoreDraw.apply(this, arguments);
  }

  function updateCommit(_x23, _x24) {
    return _updateCommit.apply(this, arguments);
  }

  function _updateCommit() {
    _updateCommit = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee28(nominationId, commit) {
      var res;
      return regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.prev = 0;
              _context28.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].updateNominationCommit(draftId.value, {
                ids: [nominationId],
                commit: commit
              });

            case 3:
              res = _context28.sent;
              patchDraws(res.data.data);
              return _context28.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 8:
              _context28.prev = 8;
              _context28.t0 = _context28["catch"](0);
              return _context28.abrupt("return", {
                message: extractError(_context28.t0),
                type: 'warning'
              });

            case 11:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28, null, [[0, 8]]);
    }));
    return _updateCommit.apply(this, arguments);
  }

  function togglePaymentStatus(_x25) {
    return _togglePaymentStatus.apply(this, arguments);
  }

  function _togglePaymentStatus() {
    _togglePaymentStatus = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee29(draw) {
      var nom, newStatus, res;
      return regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              nom = draw.nomination;

              if (!(nom == null)) {
                _context29.next = 3;
                break;
              }

              return _context29.abrupt("return", {
                message: null,
                type: 'warning'
              });

            case 3:
              if (!(nom.commit == null || nom.commit === '')) {
                _context29.next = 5;
                break;
              }

              return _context29.abrupt("return", {
                message: 'Please set up the payment type',
                type: 'warning'
              });

            case 5:
              newStatus = !nom.is_paid;
              _context29.prev = 6;
              _context29.next = 9;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].updateNominationPayment(draftId.value, {
                items: [{
                  id: nom.id,
                  is_paid: newStatus ? 1 : 0
                }]
              });

            case 9:
              res = _context29.sent;
              patchDraws(res.data.data);
              return _context29.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 14:
              _context29.prev = 14;
              _context29.t0 = _context29["catch"](6);
              return _context29.abrupt("return", {
                message: extractError(_context29.t0),
                type: 'warning'
              });

            case 17:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29, null, [[6, 14]]);
    }));
    return _togglePaymentStatus.apply(this, arguments);
  }

  function reorderDraw(_x26, _x27) {
    return _reorderDraw.apply(this, arguments);
  }

  function _reorderDraw() {
    _reorderDraw = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee30(drawId, newOrder) {
      var notify,
          list,
          idx,
          oldOrder,
          snapshot,
          minO,
          maxO,
          shift,
          res,
          _args30 = arguments;
      return regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              notify = _args30.length > 2 && _args30[2] !== undefined ? _args30[2] : false;
              list = draws.value;
              idx = list.findIndex(function (d) {
                return d.id === drawId;
              });

              if (!(idx === -1)) {
                _context30.next = 5;
                break;
              }

              return _context30.abrupt("return", {
                message: null,
                type: 'warning'
              });

            case 5:
              oldOrder = list[idx].order;

              if (!(oldOrder === newOrder)) {
                _context30.next = 8;
                break;
              }

              return _context30.abrupt("return", {
                message: null,
                type: 'warning'
              });

            case 8:
              snapshot = list.map(function (d) {
                return {
                  id: d.id,
                  order: d.order
                };
              });
              minO = Math.min(oldOrder, newOrder);
              maxO = Math.max(oldOrder, newOrder);
              shift = oldOrder < newOrder ? -1 : 1;
              list.forEach(function (d, i) {
                if (d.id === drawId) {
                  list.splice(i, 1, Object.assign({}, d, {
                    order: newOrder
                  }));
                } else if (d.order >= minO && d.order <= maxO) {
                  list.splice(i, 1, Object.assign({}, d, {
                    order: d.order + shift
                  }));
                }
              });
              _context30.prev = 13;
              _context30.next = 16;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].reorder(eventId.value, activeRound.value, {
                draw_id_from: drawId,
                order: newOrder,
                notify: notify
              });

            case 16:
              res = _context30.sent;
              fetchEmptySlots();
              return _context30.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 21:
              _context30.prev = 21;
              _context30.t0 = _context30["catch"](13);
              snapshot.forEach(function (s) {
                var i = list.findIndex(function (d) {
                  return d.id === s.id;
                });
                if (i !== -1) list.splice(i, 1, Object.assign({}, list[i], {
                  order: s.order
                }));
              });
              return _context30.abrupt("return", {
                message: extractError(_context30.t0),
                type: 'warning'
              });

            case 25:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30, null, [[13, 21]]);
    }));
    return _reorderDraw.apply(this, arguments);
  }

  function setWinner(_x28) {
    return _setWinner.apply(this, arguments);
  }

  function _setWinner() {
    _setWinner = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee31(drawId) {
      var res;
      return regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.prev = 0;
              _context31.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].setWinner(drawId);

            case 3:
              res = _context31.sent;
              patchDraws(res.data.data);
              return _context31.abrupt("return", {
                message: res.data.message || null,
                type: 'success'
              });

            case 8:
              _context31.prev = 8;
              _context31.t0 = _context31["catch"](0);
              return _context31.abrupt("return", {
                message: extractError(_context31.t0),
                type: 'warning'
              });

            case 11:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31, null, [[0, 8]]);
    }));
    return _setWinner.apply(this, arguments);
  }

  function createCalculator() {
    return _createCalculator.apply(this, arguments);
  }

  function _createCalculator() {
    _createCalculator = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee32() {
      var res;
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.prev = 0;
              _context32.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_calculators__["a" /* default */].createCalculator(eventId.value, {});

            case 3:
              res = _context32.sent;
              return _context32.abrupt("return", {
                id: res.data.data.id,
                message: res.data.message || null,
                type: 'success'
              });

            case 7:
              _context32.prev = 7;
              _context32.t0 = _context32["catch"](0);
              return _context32.abrupt("return", {
                id: null,
                message: extractError(_context32.t0),
                type: 'warning'
              });

            case 10:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, null, [[0, 7]]);
    }));
    return _createCalculator.apply(this, arguments);
  }

  function generateNext(_x29) {
    return _generateNext.apply(this, arguments);
  }

  function _generateNext() {
    _generateNext = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee33(score) {
      var fromEventId, dbRound, res, data;
      return regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              fromEventId = roundMeta.value && roundMeta.value.drawEventId ? roundMeta.value.drawEventId : eventId.value;
              dbRound = activeRound.value - 1;
              _context33.prev = 2;
              _context33.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].generateNext(fromEventId, {
                round: dbRound,
                count: score != null ? Number(score) : 0
              });

            case 5:
              res = _context33.sent;
              data = res.data.data;
              return _context33.abrupt("return", {
                message: res.data.message || null,
                type: 'success',
                round: data != null && data.round != null ? data.round : null
              });

            case 10:
              _context33.prev = 10;
              _context33.t0 = _context33["catch"](2);
              return _context33.abrupt("return", {
                message: extractError(_context33.t0),
                type: 'warning'
              });

            case 13:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33, null, [[2, 10]]);
    }));
    return _generateNext.apply(this, arguments);
  }

  function generateInto(_x30, _x31) {
    return _generateInto.apply(this, arguments);
  }

  function _generateInto() {
    _generateInto = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee34(toEventId, score) {
      var fromEventId, dbRound, res, data;
      return regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              fromEventId = roundMeta.value && roundMeta.value.drawEventId ? roundMeta.value.drawEventId : eventId.value;
              dbRound = activeRound.value - 1;
              _context34.prev = 2;
              _context34.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].generateInto(fromEventId, toEventId, {
                round: dbRound,
                count: score != null ? Number(score) : 0
              });

            case 5:
              res = _context34.sent;
              data = res.data.data;
              return _context34.abrupt("return", {
                message: res.data.message || null,
                type: 'success',
                round: data != null && data.round != null ? data.round : null
              });

            case 10:
              _context34.prev = 10;
              _context34.t0 = _context34["catch"](2);
              return _context34.abrupt("return", {
                message: extractError(_context34.t0),
                type: 'warning'
              });

            case 13:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34, null, [[2, 10]]);
    }));
    return _generateInto.apply(this, arguments);
  }

  return {
    meta: meta,
    draws: draws,
    loading: loading,
    loadingMore: loadingMore,
    hasMore: hasMore,
    eventInfo: eventInfo,
    redirectTo: redirectTo,
    activeRound: activeRound,
    draft: draft,
    eventName: eventName,
    judgesNum: judgesNum,
    autoSendTexts: autoSendTexts,
    rounds: rounds,
    eventRoundsNum: eventRoundsNum,
    lastRoundIndex: lastRoundIndex,
    calculatorId: calculatorId,
    calculator: calculator,
    finalRoundExists: finalRoundExists,
    isParentSplit: isParentSplit,
    isBrotherCombSplit: isBrotherCombSplit,
    parentEventId: parentEventId,
    childEventId: childEventId,
    childrenEventListWithParent: childrenEventListWithParent,
    finalEvent: finalEvent,
    allSiblingsHaveDraws: allSiblingsHaveDraws,
    existScratchedDraw: existScratchedDraw,
    draftEvents: draftEvents,
    refundQueueNotEmpty: refundQueueNotEmpty,
    paymentMethods: paymentMethods,
    disabledPaymentMethods: disabledPaymentMethods,
    scoreLimits: scoreLimits,
    roundMeta: roundMeta,
    emptyDrawsOrders: emptyDrawsOrders,
    emptySlots: emptySlots,
    swapCandidates: swapCandidates,
    swapCandidatesLoading: swapCandidatesLoading,
    unpublishedDrawsCount: unpublishedDrawsCount,
    showNotificationsModal: showNotificationsModal,
    isNextRoundGenerated: isNextRoundGenerated,
    showRunOffPanel: showRunOffPanel,
    hasTiedWinners: hasTiedWinners,
    refreshTieCheck: refreshTieCheck,
    fetchMeta: fetchMeta,
    fetchDraws: fetchDraws,
    loadMore: loadMore,
    fetchAll: fetchAll,
    refreshDraws: refreshDraws,
    refreshDrawsAndMeta: refreshDrawsAndMeta,
    setRound: setRound,
    markDraw: markDraw,
    deleteDraw: deleteDraw,
    moveDraw: moveDraw,
    swapDraws: swapDraws,
    refundDraws: refundDraws,
    fetchRefundStatus: fetchRefundStatus,
    cleanSlate: cleanSlate,
    publishRound: publishRound,
    resetTotalScore: resetTotalScore,
    resendNotifications: resendNotifications,
    updateStatus: updateStatus,
    regenerateFirstRound: regenerateFirstRound,
    generateRound: generateRound,
    createCalculator: createCalculator,
    generateNext: generateNext,
    generateInto: generateInto,
    generateRunOff: generateRunOff,
    insertDraw: insertDraw,
    restoreDraw: restoreDraw,
    setWinner: setWinner,
    reorderDraw: reorderDraw,
    updateCommit: updateCommit,
    togglePaymentStatus: togglePaymentStatus,
    fetchSwapCandidates: fetchSwapCandidates
  };
}

/***/ }),

/***/ 1392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawRow_vue__ = __webpack_require__(1262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635d00b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawRow_vue__ = __webpack_require__(1395);
function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-635d00b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635d00b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("0dbeff1a", content, true, {});

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".draws-table__totals-group[data-v-635d00b4]{display:flex;flex-wrap:nowrap}.row-label[data-v-635d00b4]{@media (min-width:1441px){display:none!important}}.multi-judge-row .draws-table__col.\\--names[data-v-635d00b4]{align-self:flex-start}.multi-judge-row .draws-table__totals-group[data-v-635d00b4]{align-self:stretch}.multi-judge-row .draws-table__col.\\--total[data-v-635d00b4]{align-self:stretch;flex-direction:column;justify-content:flex-end;align-items:center}.multi-judge-row .draws-table__total-value[data-v-635d00b4]{font-size:16px;line-height:18px}.draws-table__row:not(.multi-judge-row) .draws-table__col.\\--total[data-v-635d00b4]{align-self:center;-webkit-transform:translateY(-8px);transform:translateY(-8px)}.draws-table__col.\\--inputs[data-v-635d00b4]{flex-direction:column;align-items:stretch}.judge-scores-row[data-v-635d00b4]{display:flex;align-items:flex-end;width:100%}.judge-scores-row+.judge-scores-row[data-v-635d00b4]{margin-top:6px}.judge-scores-row--average[data-v-635d00b4]{font-weight:600;border-top:1px solid #d8d8d8;margin-top:4px;padding-top:4px}.judge-scores-row--average .draws-table__cell[data-v-635d00b4]{padding-top:2px;text-align:center}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Draws/DrawRow.vue"],"names":[],"mappings":"AACA,4CACE,aAAc,AACd,gBAAkB,CACnB,AACD,4BACA,0BACI,sBAAyB,CAC5B,CACA,AACD,6DACE,qBAAuB,CACxB,AACD,6DACE,kBAAoB,CACrB,AACD,6DACE,mBAAoB,AACpB,sBAAuB,AACvB,yBAA0B,AAC1B,kBAAoB,CACrB,AACD,4DACE,eAAgB,AAChB,gBAAkB,CACnB,AACD,oFACE,kBAAmB,AACnB,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,6CACE,sBAAuB,AACvB,mBAAqB,CACtB,AACD,mCACE,aAAc,AACd,qBAAsB,AACtB,UAAY,CACb,AACD,qDACE,cAAgB,CACjB,AACD,4CACE,gBAAiB,AACjB,6BAA8B,AAC9B,eAAgB,AAChB,eAAiB,CAClB,AACD,+DACE,gBAAiB,AACjB,iBAAmB,CACpB","file":"DrawRow.vue","sourcesContent":["\n.draws-table__totals-group[data-v-635d00b4] {\n  display: flex;\n  flex-wrap: nowrap;\n}\n.row-label[data-v-635d00b4] {\n@media (min-width: 1441px) {\n    display: none !important;\n}\n}\n.multi-judge-row .draws-table__col.--names[data-v-635d00b4] {\n  align-self: flex-start;\n}\n.multi-judge-row .draws-table__totals-group[data-v-635d00b4] {\n  align-self: stretch;\n}\n.multi-judge-row .draws-table__col.--total[data-v-635d00b4] {\n  align-self: stretch;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n}\n.multi-judge-row .draws-table__total-value[data-v-635d00b4] {\n  font-size: 16px;\n  line-height: 18px;\n}\n.draws-table__row:not(.multi-judge-row) .draws-table__col.--total[data-v-635d00b4] {\n  align-self: center;\n  -webkit-transform: translateY(-8px);\n          transform: translateY(-8px);\n}\n.draws-table__col.--inputs[data-v-635d00b4] {\n  flex-direction: column;\n  align-items: stretch;\n}\n.judge-scores-row[data-v-635d00b4] {\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n}\n.judge-scores-row + .judge-scores-row[data-v-635d00b4] {\n  margin-top: 6px;\n}\n.judge-scores-row--average[data-v-635d00b4] {\n  font-weight: 600;\n  border-top: 1px solid #d8d8d8;\n  margin-top: 4px;\n  padding-top: 4px;\n}\n.judge-scores-row--average .draws-table__cell[data-v-635d00b4] {\n  padding-top: 2px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-alert',{attrs:{"message":_vm.alertMessage,"type":_vm.alertType}}),_vm._v(" "),_c('div',{class:[
      'draws-table__row',
      { scratched: !_vm.draw.is_active, 'multi-judge-row': _vm.judgesNum > 1 }
    ]},[_c('div',{class:['draws-table__col --names', { 'extra_names_width': _vm.roundType !== 1 }]},[_c('div',{staticClass:"draws-table__names-group"},[_c('div',{staticClass:"draws-table__lead"},[(!_vm.draw.is_published)?_c('span',{staticClass:"sort-handle sortable-arrows drag-handle"}):_vm._e(),_vm._v(" "),_c('span',{class:['row-number', { 'pl-2': _vm.draw.is_published }]},[_vm._v("\n          "+_vm._s(_vm.draw.order + 1)+".\n        ")])]),_vm._v(" "),_c('div',{staticClass:"draws-table__cell draws-table__cell--member"},[_vm._v("\n        "+_vm._s(_vm.memberName)+"\n        "),(_vm.draw.member && _vm.draw.member.deleted)?[_c('br'),_c('em',{staticStyle:{"color":"var(--primary)","font-size":"0.7em"}},[_vm._v("(deleted)")])]:_vm._e(),_vm._v(" "),(_vm.eventLabel)?[_c('br'),_c('em',{staticStyle:{"color":"var(--primary)","font-size":"0.7em"}},[_vm._v("(events: "+_vm._s(_vm.eventLabel)+")")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"draws-table__cell draws-table__cell--horse"},[_vm._v("\n        "+_vm._s(_vm.draw.horse != null ? _vm.draw.horse.name : '')+"\n        "),(_vm.draw.horse && _vm.draw.horse.deleted)?[_c('br'),_c('em',{staticStyle:{"color":"var(--primary)","font-size":"0.7em"}},[_vm._v("(deleted)")])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"draws-table__cell actions nomination_status"},[(_vm.hasMember)?[_c('app-multiselect',{key:'move-' + _vm.draw.id + '-' + _vm.draw.order,staticClass:"multiselect--sm draws-table__move-select",attrs:{"value":null,"options":_vm.moveOptions,"label":"label","track-by":"value","searchable":false,"allow-empty":true,"placeholder":"Move to"},on:{"input":_vm.onMoveSelect}}),_vm._v(" "),_c('app-multiselect',{staticClass:"multiselect--sm draws-table__commit-select",attrs:{"value":_vm.currentCommitOption,"options":_vm.commitOptionsWithNull,"label":"label","track-by":"value","searchable":false,"allow-empty":false,"placeholder":"-"},on:{"input":_vm.onCommitChange}}),_vm._v(" "),_c('button',{staticClass:"draws-table__scratch btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('scratch', _vm.draw)}}},[_c('i',{staticClass:"scratch_draw"})]),_vm._v(" "),_c('i',{class:['pay_status', _vm.isPaid ? 'paid' : 'unpaid'],on:{"click":function($event){return _vm.$emit('toggle-payment', _vm.draw)}}})]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"draws-table__scores"},[_c('div',{staticClass:"draws-table__col --inputs"},[_vm._l((_vm.judgeNumbersList()),function(judgeNumber){return _c('div',{key:judgeNumber,staticClass:"judge-scores-row"},_vm._l((_vm.scoreLimits),function(limit,limitIndex){return _c('div',{key:limit.type,staticClass:"draws-table__cell position-relative"},[(judgeNumber === 1)?_c('label',{staticClass:"row-label draws-table__label"},[_vm._v(_vm._s(limit.label))]):_vm._e(),_vm._v(" "),_c('input',{class:{ disabled: _vm.scoreDisabled || _vm.isFieldPending(judgeNumber, limit.type) },attrs:{"type":"text","placeholder":"-","disabled":_vm.scoreDisabled || _vm.isFieldPending(judgeNumber, limit.type),"data-score-input":"","data-limit-index":limitIndex,"data-judge-index":judgeNumber},domProps:{"value":_vm.judgeValue(judgeNumber, limit.type)},on:{"input":function($event){return _vm.maskScore(judgeNumber, limit, $event)},"change":function($event){return _vm.emitMark(judgeNumber, limit, $event)},"keydown":function($event){return _vm.onScoreKeydown($event)}}}),_vm._v(" "),(_vm.isFieldPending(judgeNumber, limit.type))?_c('span',{staticClass:"spinner-border spinner-border-sm position-absolute",staticStyle:{"right":"8px","top":"50%","margin-top":"-7px"}}):_vm._e()])}),0)}),_vm._v(" "),(_vm.judgesNum > 1)?_c('div',{staticClass:"judge-scores-row judge-scores-row--average"},_vm._l((_vm.scoreLimits),function(limit){return _c('div',{key:limit.type,staticClass:"draws-table__cell"},[_vm._v("\n        "+_vm._s(_vm.averagePreviewValues()[limit.type])+"\n      ")])}),0):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"draws-table__totals-group"},[_c('div',{staticClass:"draws-table__col --total"},[_c('div',{staticClass:"row-label draws-table__label"},[_vm._v(_vm._s(_vm.totalLabel))]),_vm._v(" "),_c('div',{staticClass:"draws-table__total-value"},[_vm._v(_vm._s(_vm.formatScore(_vm.draw.total)))])]),_vm._v(" "),(_vm.roundType >= 2)?_c('div',{staticClass:"draws-table__col --total"},[_c('div',{staticClass:"row-label draws-table__label"},[_vm._v("Total score")]),_vm._v(" "),_c('div',{staticClass:"draws-table__total-value"},[_vm._v(_vm._s(_vm.formatScore(_vm.draw.totals_sum)))])]):_vm._e()])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('form-alert',{staticClass:"mb-3",attrs:{"message":_vm.alert.message.value,"type":_vm.alert.type.value}}),_vm._v(" "),_c('div',{staticClass:"draws"},[_c('div',{staticClass:"drafts__title drafts__title_flex mb-4"},[_c('h1',{staticClass:"h2 m-0"},[_vm._v(_vm._s(_vm.displayEventName))]),_vm._v(" "),(_vm.draftEvents.length > 1)?_c('div',{staticClass:"draws-event-switch",on:{"click":function($event){$event.stopPropagation();}}},[_c('app-tooltip',{staticClass:"d-inline-block",attrs:{"text":_vm.showEventSwitch ? '' : 'Switch to another event of this draft'}},[_c('button',{staticClass:"btn btn-link p-0 ml-2 dropdown-toggle draws-event-switch__btn",attrs:{"type":"button","aria-label":"Switch event"},on:{"click":function($event){_vm.showEventSwitch = !_vm.showEventSwitch}}})]),_vm._v(" "),(_vm.showEventSwitch)?_c('ul',{staticClass:"draws-event-switch__menu"},_vm._l((_vm.draftEvents),function(e){return _c('li',{key:e.id},[_c('router-link',{class:{ 'draws-event-switch__item--active': String(e.id) === String(_vm.eventId) },attrs:{"to":_vm.eventSwitchTarget(e)},nativeOn:{"click":function($event){_vm.showEventSwitch = false}}},[_vm._v(_vm._s(e.name))])],1)}),0):_vm._e()],1):_vm._e(),_vm._v(" "),_c('a',{staticClass:"draws__download-table",class:{ 'draws__download--loading': _vm.downloadingPrint === 0 },attrs:{"href":"#","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.downloadPrint(0)}}}),_vm._v(" "),_c('a',{staticClass:"draws__download-csv",class:{ 'draws__download--loading': _vm.downloadingCsv },attrs:{"href":"#","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.downloadCsv($event)}}}),_vm._v(" "),(_vm.finalRoundExists)?_c('div',{staticClass:"drafts__title-links"},[(_vm.calculatorId)?[(_vm.calculator && _vm.calculator.initialized)?_c('router-link',{staticClass:"btn btn-sm btn-outline-primary px-lg-3",attrs:{"to":'/prizes/' + _vm.eventId}},[_vm._v("\n              View results\n            ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-sm btn-outline-primary px-lg-3",attrs:{"to":'/calculators/' + _vm.eventId}},[_vm._v("\n              Edit calculations\n            ")])]:_c('button',{staticClass:"btn btn-sm btn-primary px-lg-3",attrs:{"type":"button","disabled":_vm.hasTiedWinners || _vm.actionLoading || _vm.isMarking},on:{"click":_vm.onFinaliseEvent}},[_vm._v("\n            Finalise event and calculate prize money\n          ")])],2):_vm._e()]),_vm._v(" "),_c('tab-search-bar',{attrs:{"items":_vm.roundTabItems,"active-tab":String(_vm.activeRound),"search":_vm.search,"placeholder":"Competitor or horse"},on:{"tab-change":function($event){_vm.onRoundChange(Number($event))},"search-input":function($event){_vm.search = $event}}}),_vm._v(" "),_c('div',{staticClass:"draws-tabs__content-wrap"},[_c('div',{staticClass:"draws-tabs__content active"},[(_vm.unpublishedDrawsCount > 0)?_c('div',{staticClass:"alert alert-info alert-simple"},[_vm._v("\n            "+_vm._s(_vm.unpublishedDrawsCount)+" of the runs are not published.\n            To add points, please publish the draw.\n          ")]):_vm._e(),_vm._v(" "),(_vm.unpublishedDrawsCount > 0)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.actionLoading || _vm.isMarking},on:{"click":function($event){_vm.showPublishConfirm = true}}},[_vm._v("\n            Publish the draw\n          ")]):_vm._e(),_vm._v(" "),(_vm.canResetTotalScore)?_c('div',{staticClass:"pt-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.actionLoading || _vm.isMarking},on:{"click":function($event){_vm.showCleanSlateConfirm = true}}},[_vm._v("\n              Clean slate\n            ")])]):_vm._e(),_vm._v(" "),(_vm.activeRound === 1 && !_vm.isNextRoundGenerated)?_c('div',{staticClass:"pt-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.actionLoading || _vm.isMarking},on:{"click":function($event){_vm.showRegenerateConfirm = true}}},[_vm._v("\n              Re-generate the draw\n            ")])]):_vm._e(),_vm._v(" "),(_vm.unpublishedDrawsCount === 0)?_c('div',{staticClass:"pt-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.actionLoading || _vm.isMarking},on:{"click":_vm.onResendNotifications}},[_vm._v("\n              Resend notifications\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"draws-generate bg-lighter border-top px-3 py-4 mt-4"},[_c('div',{staticClass:"draws-generate__row"},[(_vm.currentRoundType === 1 || _vm.currentRoundType === 2)?_c('div',{staticClass:"draws-generate__wrap"},[(!_vm.isCombinedNotSplit)?[_c('form',{staticClass:"draws-generate__form pb-2",on:{"submit":function($event){$event.preventDefault();return _vm.onGenerateNext($event)}}},[_c('label',{attrs:{"for":"draws-generate-number"}},[_vm._v(_vm._s(_vm.generateLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.generateScore),expression:"generateScore"}],staticClass:"draws-generate__input form-control",attrs:{"id":"draws-generate-number","type":"number","min":"0","placeholder":"0"},domProps:{"value":(_vm.generateScore)},on:{"keydown":_vm.onPositiveIntKeydown,"input":function($event){if($event.target.composing){ return; }_vm.generateScore=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary draws-generate__btn",attrs:{"type":"submit","value":"Generate","disabled":_vm.actionLoading || _vm.isMarking}})]),_vm._v(" "),(_vm.isParentSplit && _vm.activeRound === 1 && _vm.finalEvent)?_c('form',{staticClass:"draws-generate__form pb-2",on:{"submit":function($event){$event.preventDefault();return _vm.onGenerateInto(_vm.finalEvent.id)}}},[_c('label',[_vm._v("Minimum score to go to "+_vm._s(_vm.finalEvent.name))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.generateScores[_vm.finalEvent.id]),expression:"generateScores[finalEvent.id]"}],staticClass:"draws-generate__input form-control",attrs:{"type":"number","min":"0","placeholder":"0"},domProps:{"value":(_vm.generateScores[_vm.finalEvent.id])},on:{"keydown":_vm.onPositiveIntKeydown,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.generateScores, _vm.finalEvent.id, $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary draws-generate__btn",attrs:{"type":"submit","value":"Generate","disabled":_vm.actionLoading || _vm.isMarking}})]):_vm._e()]:_vm._l((_vm.childEvents),function(child){return _c('form',{key:'gen-' + child.id,staticClass:"draws-generate__form pb-2",on:{"submit":function($event){$event.preventDefault();return _vm.onGenerateInto(child.id)}}},[_c('label',{staticClass:"on-mobile-label"},[_vm._v("Minimum score to go into the "+_vm._s(child.name))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.generateScores[child.id]),expression:"generateScores[child.id]"}],staticClass:"draws-generate__input form-control",attrs:{"type":"number","min":"0","placeholder":"0"},domProps:{"value":(_vm.generateScores[child.id])},on:{"keydown":_vm.onPositiveIntKeydown,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.generateScores, child.id, $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary draws-generate__btn",attrs:{"type":"submit","value":"Generate","disabled":_vm.actionLoading || _vm.isMarking}})])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"draws-generate__reassign"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":'/nominations/' + _vm.draftId + '/reassign-member'}},[_vm._v("\n                  Re-assign nominations\n                ")])],1),_vm._v(" "),(_vm.activeRound === 1)?_c('div',{staticClass:"draws-generate__refund"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.existScratchedDraw || _vm.actionLoading || _vm.isMarking || _vm.refundQueueNotEmpty},on:{"click":function($event){_vm.showRefundConfirm = true}}},[_vm._v("\n                  Refund\n                ")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"draws-generate__add-btn btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.actionLoading || _vm.isMarking},on:{"click":function($event){_vm.showAddNomination = !_vm.showAddNomination}}},[_vm._v("\n                "+_vm._s(_vm.addNomButtonLabel)+"\n              ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.showAddNomination)?_c('div',{staticClass:"draws-generate__adding"},[_c('div',{staticClass:"add-nomination"},[_c('form',{staticClass:"nominations form",on:{"submit":function($event){$event.preventDefault();return _vm.onAddNomination($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"add-horse__form-label"},[_vm._v("\n                      Enter the competitor"),_c('br'),_vm._v("\n                      to "+_vm._s(_vm.isFirstRoundInsert ? 'nominate' : 'restore')+" for\n                    ")]),_vm._v(" "),_c('app-multiselect',{attrs:{"value":_vm.nomMember,"options":_vm.nomMemberOptions,"label":"label","track-by":"id","placeholder":"Select competitor","searchable":true,"loading":_vm.nomMemberLoading,"internal-search":false,"allow-empty":true},on:{"search-change":_vm.onMemberSearch,"input":_vm.onMemberSelect,"open":_vm.onMemberDropdownOpen}},[(!_vm.nomMemberLoading && _vm.nomMemberOptions.length === 0)?_c('template',{slot:"beforeList"},[_c('li',{staticClass:"multiselect__element"},[_c('span',{staticClass:"multiselect__option"},[_vm._v(_vm._s(_vm.nomMemberEmptyMessage))])])]):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"add-horse__form-label"},[_vm._v("\n                      Choose the vacant"),_c('br'),_vm._v("\n                      place for nomination\n                    ")]),_vm._v(" "),_c('app-multiselect',{attrs:{"value":_vm.nomPlace,"options":_vm.nomPlaceOptions,"label":"label","track-by":"id","placeholder":"Select place","searchable":false,"allow-empty":true},on:{"input":function($event){_vm.nomPlace = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"add-horse__form-label"},[_vm._v("Choose the horse")]),_vm._v(" "),_c('app-multiselect',{attrs:{"value":_vm.nomHorse,"options":_vm.nomHorseOptions,"label":"label","track-by":"id","placeholder":"Select horse","searchable":true,"loading":_vm.nomHorseLoading,"allow-empty":true},on:{"input":function($event){_vm.nomHorse = $event}}},[(!_vm.nomHorseLoading && _vm.nomHorseOptions.length === 0)?_c('template',{slot:"beforeList"},[_c('li',{staticClass:"multiselect__element"},[_c('span',{staticClass:"multiselect__option"},[_vm._v(_vm._s(_vm.nomMember ? 'No horses found' : 'Select a competitor first'))])])]):_vm._e()],2)],1),_vm._v(" "),(_vm.showEventSelect)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"add-horse__form-label"},[_vm._v("Choose event")]),_vm._v(" "),_c('app-multiselect',{attrs:{"value":_vm.nomEvent,"options":_vm.nomEventOptions,"label":"label","track-by":"id","placeholder":"Select event","searchable":false,"allow-empty":true,"disabled":_vm.isEventSelectIgnored},on:{"input":function($event){_vm.nomEvent = $event}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.nomEventHelpText))])],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":!_vm.nomMember || !_vm.nomHorse || !_vm.nomPlace || _vm.nomSubmitting}},[_vm._v("\n                    "+_vm._s(_vm.addNomButtonLabel)+"\n                  ")])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-lg-end mt-lg-3"},[_c('button',{staticClass:"draws-generate__add-btn btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.actionLoading || _vm.isMarking},on:{"click":function($event){_vm.showSwapNominations = !_vm.showSwapNominations}}},[_vm._v("\n                Swap Nominations\n              ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.showSwapNominations)?_c('div',{staticClass:"draws-nominations__swapping mt-3"},[_c('form',{staticClass:"d-flex",on:{"submit":function($event){$event.preventDefault();return _vm.onSwap($event)}}},[_c('div',{staticClass:"col col-lg-4 p-0"},[(_vm.swapCandidatesLoading)?_c('div',{staticClass:"text-muted py-2"},[_vm._v("Loading candidates...")]):[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"add-horse__form-label"},[_vm._v("First Nomination")]),_vm._v(" "),_c('app-multiselect',{attrs:{"value":_vm.swapFrom,"options":_vm.swapOptions,"label":"label","track-by":"id","placeholder":"Select","searchable":true,"allow-empty":true},on:{"input":function($event){_vm.swapFrom = $event}}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"add-horse__form-label"},[_vm._v("Second Nomination")]),_vm._v(" "),_c('app-multiselect',{attrs:{"value":_vm.swapTo,"options":_vm.swapOptions,"label":"label","track-by":"id","placeholder":"Select","searchable":true,"allow-empty":true},on:{"input":function($event){_vm.swapTo = $event}}})],1),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"submit","value":"Swap","disabled":!_vm.swapFrom || !_vm.swapTo || _vm.swapFrom.id === _vm.swapTo.id}})]],2)])]):_vm._e()])],1),_vm._v(" "),((_vm.currentRoundType === 3 || _vm.currentRoundType === 4) && _vm.hasTiedWinners && !(_vm.currentRoundType === 3 && _vm.showRunOffPanel))?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"alert alert-warning text-center"},[_c('span',{staticClass:"draws-dashboard__warn-icon"}),_vm._v("\n              "+_vm._s(_vm.currentRoundType === 4 ? 'There are some competitors that are tied for 1st after the completion of the RUN-OFF. Please, adjust the scores so that there is 1 winner.' : 'There are some competitors that are tied for 1st after the completion of the final round.')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.actionLoading || _vm.isMarking},on:{"click":_vm.onGenerateRunOff}},[_vm._v("\n                Add a run-off\n              ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"draws-table-wrap position-relative",staticStyle:{"min-height":"100px"}},[(_vm.actionLoading || _vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),_c('div',{class:['draws-table', { 'draws-table__content-last': _vm.currentRoundType !== 1 }]},[_c('div',{staticClass:"draws-table__headers"},[_c('div',{staticClass:"draws-table__header-main"},[_c('div',{staticClass:"draws-table__row"},[_c('div',{class:['draws-table__heading --runs sorting-enabled', { sorted: _vm.sortField === 'order' && _vm.sortDir === 'asc', 'sorted-desc': _vm.sortField === 'order' && _vm.sortDir === 'desc' }]},[_c('span',{on:{"click":function($event){return _vm.toggleSort('order')}}},[_vm._v("Runs"),_c('button',{staticClass:"draws-table__sort",attrs:{"type":"button"}})])]),_vm._v(" "),_c('div',{class:['draws-table__heading --total-score sorting-enabled', { sorted: _vm.sortField === 'total' && _vm.sortDir === 'asc', 'sorted-desc': _vm.sortField === 'total' && _vm.sortDir === 'desc', 'extra_score_width': _vm.currentRoundType !== 1 }]},[(_vm.currentRoundType === 1)?[_c('span',{staticClass:"heading-desktop",on:{"click":function($event){return _vm.toggleSort('total')}}},[_vm._v("\n                          Round score"),_c('button',{staticClass:"draws-table__sort",attrs:{"type":"button"}})])]:(_vm.currentRoundType === 3)?[_c('span',{staticClass:"heading-desktop round-score"},[_vm._v("Final score")]),_vm._v(" "),_c('span',{staticClass:"heading-desktop",on:{"click":function($event){return _vm.toggleSort('totals_sum')}}},[_vm._v("\n                          Total score"),_c('button',{staticClass:"draws-table__sort",attrs:{"type":"button"}})])]:(_vm.currentRoundType === 4)?[_c('span',{staticClass:"heading-desktop round-score"},[_vm._v("Run-off score")]),_vm._v(" "),_c('span',{staticClass:"heading-desktop",on:{"click":function($event){return _vm.toggleSort('totals_sum')}}},[_vm._v("\n                          Total score"),_c('button',{staticClass:"draws-table__sort",attrs:{"type":"button"}})])]:[_c('span',{staticClass:"heading-desktop round-score"},[_vm._v("Round score")]),_vm._v(" "),_c('span',{staticClass:"heading-desktop",on:{"click":function($event){return _vm.toggleSort('totals_sum')}}},[_vm._v("\n                          Total score"),_c('button',{staticClass:"draws-table__sort",attrs:{"type":"button"}})])],_vm._v(" "),_c('span',{staticClass:"heading-mobile",on:{"click":function($event){return _vm.toggleSort('total')}}},[_vm._v("\n                        Sort by total"),_c('button',{staticClass:"draws-table__sort",attrs:{"type":"button"}})]),_vm._v(" "),_c('div',{staticClass:"draws-table__print",on:{"click":function($event){$event.stopPropagation();_vm.showPrintMenu = !_vm.showPrintMenu}}},[(_vm.showPrintMenu)?_c('div',{staticClass:"draws-table__print-dropdown",staticStyle:{"display":"block"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.downloadPrint(1)}}},[(_vm.downloadingPrint === 1)?_c('span',{staticClass:"draws-print-spinner mr-1"}):_vm._e(),_vm._v("Score Sheet Download\n                          ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.downloadPrint(2)}}},[(_vm.downloadingPrint === 2)?_c('span',{staticClass:"draws-print-spinner mr-1"}):_vm._e(),_vm._v("Announcer Download\n                          ")])]):_vm._e()])],2)])]),_vm._v(" "),_c('div',{staticClass:"draws-table__header-small"},[_c('div',{staticClass:"draws-table__row"},[_c('div',{class:['draws-table__col --names', { 'extra_names_width': _vm.currentRoundType !== 1 }]},[_c('div',{staticClass:"draws-table__names-group"},[_c('div',{staticClass:"draws-table__lead"}),_vm._v(" "),_c('div',{staticClass:"draws-table__cell draws-table__cell--member draws-table__heading-small"},[_vm._v("\n                          Competitor\n                        ")]),_vm._v(" "),_c('div',{staticClass:"draws-table__cell draws-table__cell--horse draws-table__heading-small"},[_vm._v("\n                          Horse\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"draws-table__col --inputs"},[_c('div',{staticClass:"draws-table__cell draws-table__heading-small"},[_vm._v("\n                        Cutout\n                      ")]),_vm._v(" "),_c('div',{staticClass:"draws-table__cell draws-table__heading-small"},[_vm._v("\n                        Horsework\n                      ")]),_vm._v(" "),_c('div',{staticClass:"draws-table__cell draws-table__heading-small"},[_vm._v("\n                        Course\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"draws-table__col --total"})])])]),_vm._v(" "),_c('draggable',{staticClass:"draws-table__body",attrs:{"value":_vm.filteredDraws,"handle":".drag-handle","animation":200},on:{"end":_vm.onDragEnd}},_vm._l((_vm.filteredDraws),function(draw){return _c('draw-row',{key:draw.id,attrs:{"draw":draw,"round-type":_vm.currentRoundType,"pending-marks":_vm.pendingMarks,"empty-slots":_vm.emptySlots,"commit-options":_vm.commitOptions,"score-limits":_vm.scoreLimits,"judges-num":_vm.judgesNum,"alert-message":_vm.rowAlerts[draw.id] != null ? _vm.rowAlerts[draw.id].message : null,"alert-type":_vm.rowAlerts[draw.id] != null ? _vm.rowAlerts[draw.id].type : 'warning'},on:{"move":function($event){return _vm.onMoveRequest($event)},"commit":function($event){_vm.handleRowAction(draw.id, _vm.updateCommit($event.nominationId, $event.commit))},"scratch":function($event){return _vm.onScratch($event)},"toggle-payment":function($event){_vm.handleRowAction(draw.id, _vm.togglePaymentStatus($event))},"mark":function($event){return _vm.onMark($event)}}})}),1),_vm._v(" "),(_vm.filteredDraws.length === 0)?_c('div',{staticClass:"alert alert-warning alert-simple rounded-0 m-0 w-100"},[_vm._v("\n                There are no results.\n              ")]):_vm._e()],1),_vm._v(" "),(_vm.hasMore)?_c('div',{staticClass:"text-center py-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.loadingMore},on:{"click":_vm.loadMoreKeepingScroll}},[_vm._v("\n                "+_vm._s(_vm.loadingMore ? 'Loading…' : 'Load more')+"\n              ")])]):_vm._e(),_vm._v(" "),_c('div',{ref:"loadMoreTrigger"})])])])],1),_vm._v(" "),(_vm.showConfirm)?_c('confirm-modal',{on:{"confirm":function($event){_vm.showConfirm = false},"close":function($event){_vm.showConfirm = false}}},[_vm._v("\n      Are you sure you want to perform this action?\n    ")]):_vm._e(),_vm._v(" "),(_vm.showRefundConfirm)?_c('modal',{on:{"close":function($event){_vm.showRefundConfirm = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center mb-0"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Would you like to retain stock levy or fully refund the nominations?")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.refundLoading},on:{"click":function($event){return _vm.onRefund('retain-stock')}}},[_vm._v("\n            Retain stock levy\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",attrs:{"disabled":_vm.refundLoading},on:{"click":function($event){return _vm.onRefund('full')}}},[_vm._v("\n            Refund fully\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.showPublishConfirm)?_c('confirm-modal',{attrs:{"message":"Draw will be published and competitors notified."},on:{"confirm":_vm.onPublish,"cancel":function($event){_vm.showPublishConfirm = false}}}):_vm._e(),_vm._v(" "),(_vm.showRegenerateConfirm)?_c('confirm-modal',{attrs:{"message":"Warning you are about to regenerate the first round draw. If you proceed the entire draw will be redone and any entered scores from this round will be lost. If you proceed this can't be undone. Would you like to proceed?"},on:{"confirm":_vm.onRegenerate,"cancel":function($event){_vm.showRegenerateConfirm = false}}}):_vm._e(),_vm._v(" "),(_vm.showCleanSlateConfirm)?_c('confirm-modal',{attrs:{"message":"Warning, all competitors in the final will have their score reset to 0."},on:{"confirm":_vm.onResetTotalScore,"cancel":function($event){_vm.showCleanSlateConfirm = false}}}):_vm._e(),_vm._v(" "),(_vm.showScratchConfirm)?_c('modal',{on:{"close":function($event){_vm.showScratchConfirm = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center mb-0"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Would you like to alert the competitor that their run/s will be scratched?")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.onScratchConfirm(true)}}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){return _vm.onScratchConfirm(false)}}},[_vm._v("No")])])])]):_vm._e(),_vm._v(" "),(_vm.showMoveNotifyConfirm)?_c('modal',{on:{"close":function($event){_vm.showMoveNotifyConfirm = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center mb-0"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Would you like to alert the competitor that their run will be moved?")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.onMoveNotifyConfirm(true)}}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){return _vm.onMoveNotifyConfirm(false)}}},[_vm._v("No")])])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.9ea699570914ee9b777b.js